// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$import(url) {  url = importMap[url] || url;  return import(distDir + url);}newRequire.load = $parcel$import;function $parcel$resolve(url) {url = importMap[url] || url;return publicUrl + url;}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"epXbR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _image = require("@react-spectrum/s2/icons/Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _copy = require("@react-spectrum/s2/icons/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _deviceTablet = require("@react-spectrum/s2/icons/DeviceTablet");
var _deviceTabletDefault = parcelHelpers.interopDefault(_deviceTablet);
var _deviceDesktop = require("@react-spectrum/s2/icons/DeviceDesktop");
var _deviceDesktopDefault = parcelHelpers.interopDefault(_deviceDesktop);
"use client";
function Example(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                children: "Publish"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
                ...props,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuSection), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Header), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                                        children: "Publish and export"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                        slot: "description",
                                        children: "Social media, other formats"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                textValue: "quick export",
                                onAction: ()=>alert('Quick export'),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageDefault.default), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                        slot: "label",
                                        children: "Quick Export"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                        slot: "description",
                                        children: "Share a low-res snapshot."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.SubmenuTrigger), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                        textValue: "open a copy",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyDefault.default), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                slot: "label",
                                                children: "Open a copy"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                slot: "description",
                                                children: "Illustrator for iPad or desktop"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Menu), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuSection), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Header), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                                                        children: "Open a copy in"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                                    textValue: "ipad",
                                                    onAction: ()=>alert('Open on iPad'),
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deviceTabletDefault.default), {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                            slot: "label",
                                                            children: "Illustrator for iPad"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                                    textValue: "desktop",
                                                    onAction: ()=>alert('Open on desktop'),
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deviceDesktopDefault.default), {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                            slot: "label",
                                                            children: "Illustrator for desktop"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuSection), {
                        selectionMode: "multiple",
                        defaultSelectedKeys: [
                            'files'
                        ],
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "files",
                                children: "Show files"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "folders",
                                children: "Show folders"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Header","10r6w"],["Heading","10r6w"],["Text","10r6w"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuSection","1F0Yz"],["MenuTrigger","1F0Yz"],["SubmenuTrigger","1F0Yz"]],"@react-spectrum/s2/icons/Image":"ld4zI","@react-spectrum/s2/icons/Copy":"6imrL","@react-spectrum/s2/icons/DeviceTablet":"WD2xG","@react-spectrum/s2/icons/DeviceDesktop":"g9qPz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ld4zI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.5 7.521c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 3H3.25C2.01 3 1 4.01 1 5.25v9.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-9.5C19 4.01 17.99 3 16.75 3M3.25 4.5h13.5c.413 0 .75.337.75.75v8.21l-1.91-1.908c-.876-.877-2.304-.877-3.18 0l-1.232 1.231c-.1.098-.257.097-.355.001L7.591 9.552c-.85-.85-2.332-.85-3.182 0L2.5 11.46V5.25c0-.413.337-.75.75-.75m0 11c-.413 0-.75-.337-.75-.75v-1.168l2.97-2.97c.293-.293.767-.293 1.06 0l3.234 3.234c.681.68 1.792.68 2.473-.001l1.233-1.233c.293-.293.767-.293 1.06 0l2.701 2.701c-.131.112-.296.187-.481.187z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a1TxN":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1803ac46c34b822c");

},{"1803ac46c34b822c":"4tF2f"}],"4tF2f":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray, ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function noop$1() {}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop$1, noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function noop() {}
exports.Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, void 0, void 0, owner, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, void 0, void 0, null, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, createDeps, update) {
    var dispatcher = ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.1.0";

},{}],"WD2xG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 5,
                cy: 9.998,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M3.25 2.998h13.5c1.24 0 2.25 1.01 2.25 2.25v9.5c0 1.24-1.01 2.25-2.25 2.25H3.25c-1.24 0-2.25-1.01-2.25-2.25v-9.5c0-1.24 1.01-2.25 2.25-2.25m13.5 12.5c.413 0 .75-.337.75-.75v-9.5c0-.413-.337-.75-.75-.75H3.25c-.413 0-.75.337-.75.75v9.5c0 .413.337.75.75.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g9qPz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M14 18.5H6c-.414 0-.75-.336-.75-.75S5.586 17 6 17h8c.414 0 .75.336.75.75s-.336.75-.75.75M16.75 16H3.25C2.01 16 1 14.99 1 13.75v-8.5C1 4.01 2.01 3 3.25 3h13.5C17.99 3 19 4.01 19 5.25v8.5c0 1.24-1.01 2.25-2.25 2.25M3.25 4.5c-.413 0-.75.337-.75.75v8.5c0 .413.337.75.75.75h13.5c.413 0 .75-.337.75-.75v-8.5c0-.413-.337-.75-.75-.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b7coD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
"use client";
let items = [
    {
        id: 'cut',
        name: 'Cut'
    },
    {
        id: 'copy',
        name: 'Copy'
    },
    {
        id: 'paste',
        name: 'Paste'
    },
    {
        id: 'select-all',
        name: 'Select All'
    }
];
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
            children: "Edit"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Menu), {
            items: items,
            children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                    children: item.name
                })
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuTrigger","1F0Yz"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bqtj1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _copy = require("@react-spectrum/s2/icons/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _cut = require("@react-spectrum/s2/icons/Cut");
var _cutDefault = parcelHelpers.interopDefault(_cut);
var _paste = require("@react-spectrum/s2/icons/Paste");
var _pasteDefault = parcelHelpers.interopDefault(_paste);
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
            children: "Edit"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                    textValue: "Copy",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                            slot: "label",
                            children: "Copy"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                            slot: "description",
                            children: "Copy the selected text"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Keyboard), {
                            children: "\u2318C"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                    textValue: "Cut",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cutDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                            slot: "label",
                            children: "Cut"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                            slot: "description",
                            children: "Cut the selected text"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Keyboard), {
                            children: "\u2318X"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                    textValue: "Paste",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pasteDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                            slot: "label",
                            children: "Paste"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                            slot: "description",
                            children: "Paste the copied text"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Keyboard), {
                            children: "\u2318V"
                        })
                    ]
                })
            ]
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Keyboard","10r6w"],["Text","10r6w"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuTrigger","1F0Yz"]],"@react-spectrum/s2/icons/Copy":"6imrL","@react-spectrum/s2/icons/Cut":"7CXbj","@react-spectrum/s2/icons/Paste":"hyJp5","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7CXbj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.477 7.606q-.121.001-.242-.04c-.392-.132-.602-.56-.468-.95L12.5 1.518c.134-.393.558-.604.951-.47s.603.56.469.952l-1.733 5.097c-.107.312-.398.508-.71.508"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M19.12 6.718c-.135-.393-.56-.604-.952-.469l-7.29 2.48c-.332.112-.692.168-1.132.232-.652.095-1.463.406-2.31.863-.031-.762-.327-1.514-.907-2.095-1.226-1.227-3.221-1.225-4.448 0-1.227 1.227-1.227 3.222 0 4.449.613.613 1.419.92 2.225.92.777 0 1.553-.294 2.158-.867.017-.011.037-.016.055-.029 1.135-.872 2.228-1.415 2.98-1.644l-.271.907c-.09.299-.187.535-.306.745-.274.485-.605.983-.955 1.441-.011.015-.013.032-.023.046-1.173 1.23-1.162 3.182.047 4.39.613.614 1.42.92 2.225.92s1.61-.306 2.223-.92c1.227-1.226 1.227-3.22 0-4.447-.583-.583-1.34-.88-2.106-.91.125-.251.238-.52.332-.834l.51-1.7c.062-.018.123-.027.185-.048l7.29-2.48c.393-.132.603-.559.47-.95m-15.978 4.4c-.642-.642-.642-1.686 0-2.328.32-.32.742-.481 1.164-.481.42 0 .841.16 1.163.481.64.642.64 1.686 0 2.327-.643.644-1.685.64-2.327 0m8.237 5.91c-.643.641-1.685.64-2.327 0-.642-.642-.642-1.686 0-2.328.64-.638 1.686-.64 2.327 0 .642.642.642 1.686 0 2.327"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hyJp5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 4,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 18H4.25C3.01 18 2 16.99 2 15.75v-9.5C2 5.01 3.01 4 4.25 4h2.252c.026-.925.407-1.783 1.079-2.426.696-.666 1.62-1.016 2.576-.966C11.91.685 13.352 2.18 13.49 4h2.261C16.99 4 18 5.01 18 6.25v9.5c0 1.24-1.01 2.25-2.25 2.25M4.25 5.5c-.413 0-.75.337-.75.75v9.5c0 .413.337.75.75.75h11.5c.413 0 .75-.337.75-.75v-9.5c0-.413-.337-.75-.75-.75H15v1.25C15 7.99 13.99 9 12.75 9h-5.5C6.01 9 5 7.99 5 6.75L4.964 5.5zm2.25 0v1.25c0 .413.337.75.75.75h5.5c.413 0 .75-.337.75-.75V5.5h-.75c-.414 0-.75-.336-.75-.75v-.466c0-1.155-.856-2.132-1.908-2.178-.558-.012-1.076.171-1.474.552S8 3.553 8 4.105v.645c0 .414-.336.75-.75.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6Gmso":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _normalPng = require("url:./assets/normal.png");
var _normalPngDefault = parcelHelpers.interopDefault(_normalPng);
var _multiplyPng = require("url:./assets/multiply.png");
var _multiplyPngDefault = parcelHelpers.interopDefault(_multiplyPng);
var _screenPng = require("url:./assets/screen.png");
var _screenPngDefault = parcelHelpers.interopDefault(_screenPng);
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
            children: "Blend mode"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                    textValue: "normal",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Image), {
                            src: (0, _normalPngDefault.default)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                            slot: "label",
                            children: "Normal"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                            slot: "description",
                            children: "No effect applied."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                    textValue: "multiply",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Image), {
                            src: (0, _multiplyPngDefault.default)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                            slot: "label",
                            children: "Multiply"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                            slot: "description",
                            children: "Add contrast, detail, and darken shadows."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                    textValue: "screen",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Image), {
                            src: (0, _screenPngDefault.default)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                            slot: "label",
                            children: "Screen"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                            slot: "description",
                            children: "Reduce contrast and brighten details."
                        })
                    ]
                })
            ]
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Image","4LTiE"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuTrigger","1F0Yz"],["Text","10r6w"]],"url:./assets/normal.png":"bHAV9","url:./assets/multiply.png":"czCxR","url:./assets/screen.png":"2Wutx","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bHAV9":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("ld31y");

},{}],"czCxR":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("5NdkH");

},{}],"2Wutx":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("5M3m2");

},{}],"5Gxpg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
            children: "Publish"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuSection), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Header), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                                    children: "Export"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                    slot: "description",
                                    children: "Save to your device"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                            children: "Image\u2026"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                            children: "Video\u2026"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                            children: "Text\u2026"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuSection), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Header), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                                    children: "Share"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                    slot: "description",
                                    children: "Share to social media"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                            children: "YouTube\u2026"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                            children: "Instagram\u2026"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                            children: "Email\u2026"
                        })
                    ]
                })
            ]
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Header","10r6w"],["Heading","10r6w"],["Text","10r6w"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuSection","1F0Yz"],["MenuTrigger","1F0Yz"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1mOHW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
            children: "Actions"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                    children: "Copy"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                    children: "Cut"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                    children: "Paste"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.SubmenuTrigger), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                            id: "share",
                            children: "Share"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Popover), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                        children: "SMS"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                        children: "Copy Link"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuTrigger","1F0Yz"],["SubmenuTrigger","1F0Yz"],["Popover","62puW"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9vr08":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
"use client";
function Example(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                children: "Links"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
                ...props,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                        href: "https://adobe.com/",
                        target: "_blank",
                        children: "Adobe"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                        href: "https://apple.com/",
                        target: "_blank",
                        children: "Apple"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                        href: "https://google.com/",
                        target: "_blank",
                        children: "Google"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                        href: "https://microsoft.com/",
                        target: "_blank",
                        children: "Microsoft"
                    })
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuTrigger","1F0Yz"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2orLH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _buildings = require("@react-spectrum/s2/icons/Buildings");
var _buildingsDefault = parcelHelpers.interopDefault(_buildings);
var _settings = require("@react-spectrum/s2/icons/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
            "aria-label": "Account",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Avatar), {
                src: "https://i.imgur.com/xIe7Wlb.png"
            })
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Popover), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " Tp12 sd12 _ta12 Ug12 qg12",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: " sd12 Ug12 qg12 eb12 Ix12 Hx12",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Avatar), {
                                src: "https://i.imgur.com/xIe7Wlb.png",
                                size: 56
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: " uk12 uch12 udi12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-d12 vx12 xd12 _xa12 xX0cczbc12 _xX0cczba12 xfd12 _xfa12 xfX0cczbc12 _xfX0cczba12 _Fd12 _FezxGHba12 _FnuYUweb12 po12",
                                        children: "Devon Govett"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: " uk12 uch12 udi12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-c12 vx12 xb12 _xa12 _Fd12 _FezxGHba12 _FnuYUweb12 pt12",
                                        children: "user@example.com"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Switch), {
                                        styles: " Js12",
                                        children: "Dark theme"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Divider), {
                        styles: " Ix12 Hx12"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
                        "aria-label": "Account",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuSection), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.SubmenuTrigger), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildingsDefault.default), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                        slot: "label",
                                                        children: "Organization"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                        slot: "value",
                                                        children: "Nike"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
                                                selectionMode: "single",
                                                selectedKeys: [
                                                    'nike'
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                                        id: "adobe",
                                                        children: "Adobe"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                                        id: "nike",
                                                        children: "Nike"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                                        id: "apple",
                                                        children: "Apple"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                slot: "label",
                                                children: "Settings"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuSection), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                        children: "Legal notices"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                        children: "Sign out"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    ]
});

},{"mdx-7:0":"bcSCt","mdx-7:1":"bcSCt","mdx-7:2":"bcSCt","mdx-7:3":"bcSCt","mdx-7:4":"bcSCt","mdx-7:5":"bcSCt","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Avatar","f3T9F"],["Divider","kGk2u"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuSection","1F0Yz"],["MenuTrigger","1F0Yz"],["SubmenuTrigger","1F0Yz"],["Popover","62puW"],["Switch","dIOQS"],["Text","10r6w"]],"@react-spectrum/s2/icons/Buildings":"81MDh","@react-spectrum/s2/icons/Settings":"kzvDN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bcSCt":[function(require,module,exports,__globalThis) {
var _serverEdge = require("react-server-dom-parcel/server.edge");
exports.__esModule = true;

},{"react-server-dom-parcel/server.edge":"74WJu"}],"74WJu":[function(require,module,exports,__globalThis) {
'use strict';
var s;
s = require("8884f512c685da86");
exports.renderToReadableStream = s.renderToReadableStream;
exports.decodeReply = s.decodeReply;
exports.decodeReplyFromAsyncIterable = s.decodeReplyFromAsyncIterable;
exports.decodeAction = s.decodeAction;
exports.decodeFormState = s.decodeFormState;
exports.createClientReference = s.createClientReference;
exports.registerServerReference = s.registerServerReference;
exports.createTemporaryReferenceSet = s.createTemporaryReferenceSet;
exports.registerServerActions = s.registerServerActions;
exports.loadServerAction = s.loadServerAction;

},{"8884f512c685da86":"iGhi4"}],"iGhi4":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-server-dom-parcel-server.edge.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactDOM = require("2381f0f3ff03ff95"), React = require("6db66a729b66b575"), ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function resolveServerReference(bundlerConfig, ref) {
    var idx = ref.lastIndexOf("#"), id = ref.slice(0, idx);
    idx = ref.slice(idx + 1);
    bundlerConfig = bundlerConfig[id];
    if (!bundlerConfig) throw Error("Invalid server action: " + ref);
    return [
        id,
        idx,
        bundlerConfig
    ];
}
function preloadModule$1(metadata) {
    metadata[3] && module.bundle.extendImportMap(metadata[3]);
    return 0 === metadata[2].length ? null : Promise.all(metadata[2].map(function(url) {
        return module.bundle.load(url);
    }));
}
function requireModule(metadata) {
    return module.bundle.root(metadata[0])[metadata[1]];
}
var REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.postpone");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ASYNC_ITERATOR = Symbol.asyncIterator;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
var LocalPromise = Promise, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : function(callback) {
    LocalPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
}, currentView = null, writtenBytes = 0;
function writeChunkAndReturn(destination, chunk) {
    if (0 !== chunk.byteLength) {
        if (2048 < chunk.byteLength) 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = new Uint8Array(2048), writtenBytes = 0), destination.enqueue(chunk);
        else {
            var allowableBytes = currentView.length - writtenBytes;
            allowableBytes < chunk.byteLength && (0 === allowableBytes ? destination.enqueue(currentView) : (currentView.set(chunk.subarray(0, allowableBytes), writtenBytes), destination.enqueue(currentView), chunk = chunk.subarray(allowableBytes)), currentView = new Uint8Array(2048), writtenBytes = 0);
            currentView.set(chunk, writtenBytes);
            writtenBytes += chunk.byteLength;
        }
    }
    return !0;
}
var textEncoder = new TextEncoder();
function stringToChunk(content) {
    return textEncoder.encode(content);
}
function byteLengthOfChunk(chunk) {
    return chunk.byteLength;
}
function closeWithError(destination, error) {
    "function" === typeof destination.error ? destination.error(error) : destination.close();
}
var CLIENT_REFERENCE_TAG$1 = Symbol.for("react.client.reference"), SERVER_REFERENCE_TAG = Symbol.for("react.server.reference"), FunctionBind = Function.prototype.bind, ArraySlice = Array.prototype.slice;
function bind() {
    var newFn = FunctionBind.apply(this, arguments);
    if (this.$$typeof === SERVER_REFERENCE_TAG) {
        var args = ArraySlice.call(arguments, 1), $$typeof = {
            value: SERVER_REFERENCE_TAG
        }, $$id = {
            value: this.$$id
        };
        args = {
            value: this.$$bound ? this.$$bound.concat(args) : args
        };
        return Object.defineProperties(newFn, {
            $$typeof: $$typeof,
            $$id: $$id,
            $$bound: args,
            bind: {
                value: bind,
                configurable: !0
            }
        });
    }
    return newFn;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: previousDispatcher.f,
    r: previousDispatcher.r,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function prefetchDNS(href) {
    if ("string" === typeof href && href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "D|" + href;
            hints.has(key) || (hints.add(key), emitHint(request, "D", href));
        } else previousDispatcher.D(href);
    }
}
function preconnect(href, crossOrigin) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "C|" + (null == crossOrigin ? "null" : crossOrigin) + "|" + href;
            hints.has(key) || (hints.add(key), "string" === typeof crossOrigin ? emitHint(request, "C", [
                href,
                crossOrigin
            ]) : emitHint(request, "C", href));
        } else previousDispatcher.C(href, crossOrigin);
    }
}
function preload(href, as, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "L";
            if ("image" === as && options) {
                var imageSrcSet = options.imageSrcSet, imageSizes = options.imageSizes, uniquePart = "";
                "string" === typeof imageSrcSet && "" !== imageSrcSet ? (uniquePart += "[" + imageSrcSet + "]", "string" === typeof imageSizes && (uniquePart += "[" + imageSizes + "]")) : uniquePart += "[][]" + href;
                key += "[image]" + uniquePart;
            } else key += "[" + as + "]" + href;
            hints.has(key) || (hints.add(key), (options = trimOptions(options)) ? emitHint(request, "L", [
                href,
                as,
                options
            ]) : emitHint(request, "L", [
                href,
                as
            ]));
        } else previousDispatcher.L(href, as, options);
    }
}
function preloadModule(href, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "m|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "m", [
                href,
                options
            ]) : emitHint(request, "m", href);
        }
        previousDispatcher.m(href, options);
    }
}
function preinitStyle(href, precedence, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "S|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "S", [
                href,
                "string" === typeof precedence ? precedence : 0,
                options
            ]) : "string" === typeof precedence ? emitHint(request, "S", [
                href,
                precedence
            ]) : emitHint(request, "S", href);
        }
        previousDispatcher.S(href, precedence, options);
    }
}
function preinitScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "X|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "X", [
                src,
                options
            ]) : emitHint(request, "X", src);
        }
        previousDispatcher.X(src, options);
    }
}
function preinitModuleScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "M|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "M", [
                src,
                options
            ]) : emitHint(request, "M", src);
        }
        previousDispatcher.M(src, options);
    }
}
function trimOptions(options) {
    if (null == options) return null;
    var hasProperties = !1, trimmed = {}, key;
    for(key in options)null != options[key] && (hasProperties = !0, trimmed[key] = options[key]);
    return hasProperties ? trimmed : null;
}
var supportsRequestStorage = "function" === typeof AsyncLocalStorage, requestStorage = supportsRequestStorage ? new AsyncLocalStorage() : null, TEMPORARY_REFERENCE_TAG = Symbol.for("react.temporary.reference"), proxyHandlers = {
    get: function(target, name) {
        switch(name){
            case "$$typeof":
                return target.$$typeof;
            case "name":
                return;
            case "displayName":
                return;
            case "defaultProps":
                return;
            case "_debugInfo":
                return;
            case "toJSON":
                return;
            case Symbol.toPrimitive:
                return Object.prototype[Symbol.toPrimitive];
            case Symbol.toStringTag:
                return Object.prototype[Symbol.toStringTag];
            case "Provider":
                throw Error("Cannot render a Client Context Provider on the Server. Instead, you can export a Client Component wrapper that itself renders a Client Context Provider.");
        }
        throw Error("Cannot access " + String(name) + " on the server. You cannot dot into a temporary client reference from a server component. You can only pass the value through to the client.");
    },
    set: function() {
        throw Error("Cannot assign to a temporary client reference from a server module.");
    }
};
function createTemporaryReference(temporaryReferences, id) {
    var reference = Object.defineProperties(function() {
        throw Error("Attempted to call a temporary Client Reference from the server but it is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component.");
    }, {
        $$typeof: {
            value: TEMPORARY_REFERENCE_TAG
        }
    });
    reference = new Proxy(reference, proxyHandlers);
    temporaryReferences.set(reference, id);
    return reference;
}
function noop() {}
var SuspenseException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`.");
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop, noop), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            "string" === typeof thenable.status ? thenable.then(noop, noop) : (thenableState = thenable, thenableState.status = "pending", thenableState.then(function(fulfilledValue) {
                if ("pending" === thenable.status) {
                    var fulfilledThenable = thenable;
                    fulfilledThenable.status = "fulfilled";
                    fulfilledThenable.value = fulfilledValue;
                }
            }, function(error) {
                if ("pending" === thenable.status) {
                    var rejectedThenable = thenable;
                    rejectedThenable.status = "rejected";
                    rejectedThenable.reason = error;
                }
            }));
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
var currentRequest$1 = null, thenableIndexCounter = 0, thenableState = null;
function getThenableStateAfterSuspending() {
    var state = thenableState || [];
    thenableState = null;
    return state;
}
var HooksDispatcher = {
    readContext: unsupportedContext,
    use: use,
    useCallback: function(callback) {
        return callback;
    },
    useContext: unsupportedContext,
    useEffect: unsupportedHook,
    useImperativeHandle: unsupportedHook,
    useLayoutEffect: unsupportedHook,
    useInsertionEffect: unsupportedHook,
    useMemo: function(nextCreate) {
        return nextCreate();
    },
    useReducer: unsupportedHook,
    useRef: unsupportedHook,
    useState: unsupportedHook,
    useDebugValue: function() {},
    useDeferredValue: unsupportedHook,
    useTransition: unsupportedHook,
    useSyncExternalStore: unsupportedHook,
    useId: useId,
    useHostTransitionStatus: unsupportedHook,
    useFormState: unsupportedHook,
    useActionState: unsupportedHook,
    useOptimistic: unsupportedHook,
    useMemoCache: function(size) {
        for(var data = Array(size), i = 0; i < size; i++)data[i] = REACT_MEMO_CACHE_SENTINEL;
        return data;
    },
    useCacheRefresh: function() {
        return unsupportedRefresh;
    }
};
function unsupportedHook() {
    throw Error("This Hook is not supported in Server Components.");
}
function unsupportedRefresh() {
    throw Error("Refreshing the cache is not supported in Server Components.");
}
function unsupportedContext() {
    throw Error("Cannot read a Client Context from a Server Component.");
}
function useId() {
    if (null === currentRequest$1) throw Error("useId can only be used while React is rendering");
    var id = currentRequest$1.identifierCount++;
    return "_" + currentRequest$1.identifierPrefix + "S_" + id.toString(32) + "_";
}
function use(usable) {
    if (null !== usable && "object" === typeof usable || "function" === typeof usable) {
        if ("function" === typeof usable.then) {
            var index = thenableIndexCounter;
            thenableIndexCounter += 1;
            null === thenableState && (thenableState = []);
            return trackUsedThenable(thenableState, usable, index);
        }
        usable.$$typeof === REACT_CONTEXT_TYPE && unsupportedContext();
    }
    if (usable.$$typeof === CLIENT_REFERENCE_TAG$1) {
        if (null != usable.value && usable.value.$$typeof === REACT_CONTEXT_TYPE) throw Error("Cannot read a Client Context from a Server Component.");
        throw Error("Cannot use() an already resolved Client Reference.");
    }
    throw Error("An unsupported type was passed to use(): " + String(usable));
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var JSCompiler_inline_result = (JSCompiler_inline_result = resolveRequest()) ? JSCompiler_inline_result.cache : new Map();
        var entry = JSCompiler_inline_result.get(resourceType);
        void 0 === entry && (entry = resourceType(), JSCompiler_inline_result.set(resourceType, entry));
        return entry;
    },
    cacheSignal: function() {
        var request = resolveRequest();
        return request ? request.cacheController.signal : null;
    }
}, ReactSharedInternalsServer = React.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
if (!ReactSharedInternalsServer) throw Error('The "react" package in this environment is not configured correctly. The "react-server" condition must be enabled in any environment that runs React Server Components.');
var isArrayImpl = Array.isArray, getPrototypeOf = Object.getPrototypeOf;
function objectName(object) {
    object = Object.prototype.toString.call(object);
    return object.slice(8, object.length - 1);
}
function describeValueForErrorMessage(value) {
    switch(typeof value){
        case "string":
            return JSON.stringify(10 >= value.length ? value : value.slice(0, 10) + "...");
        case "object":
            if (isArrayImpl(value)) return "[...]";
            if (null !== value && value.$$typeof === CLIENT_REFERENCE_TAG) return "client";
            value = objectName(value);
            return "Object" === value ? "{...}" : value;
        case "function":
            return value.$$typeof === CLIENT_REFERENCE_TAG ? "client" : (value = value.displayName || value.name) ? "function " + value : "function";
        default:
            return String(value);
    }
}
function describeElementType(type) {
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_FORWARD_REF_TYPE:
            return describeElementType(type.render);
        case REACT_MEMO_TYPE:
            return describeElementType(type.type);
        case REACT_LAZY_TYPE:
            var payload = type._payload;
            type = type._init;
            try {
                return describeElementType(type(payload));
            } catch (x) {}
    }
    return "";
}
var CLIENT_REFERENCE_TAG = Symbol.for("react.client.reference");
function describeObjectForErrorMessage(objectOrArray, expandedName) {
    var objKind = objectName(objectOrArray);
    if ("Object" !== objKind && "Array" !== objKind) return objKind;
    objKind = -1;
    var length = 0;
    if (isArrayImpl(objectOrArray)) {
        var str = "[";
        for(var i = 0; i < objectOrArray.length; i++){
            0 < i && (str += ", ");
            var value = objectOrArray[i];
            value = "object" === typeof value && null !== value ? describeObjectForErrorMessage(value) : describeValueForErrorMessage(value);
            "" + i === expandedName ? (objKind = str.length, length = value.length, str += value) : str = 10 > value.length && 40 > str.length + value.length ? str + value : str + "...";
        }
        str += "]";
    } else if (objectOrArray.$$typeof === REACT_ELEMENT_TYPE) str = "<" + describeElementType(objectOrArray.type) + "/>";
    else {
        if (objectOrArray.$$typeof === CLIENT_REFERENCE_TAG) return "client";
        str = "{";
        i = Object.keys(objectOrArray);
        for(value = 0; value < i.length; value++){
            0 < value && (str += ", ");
            var name = i[value], encodedKey = JSON.stringify(name);
            str += ('"' + name + '"' === encodedKey ? name : encodedKey) + ": ";
            encodedKey = objectOrArray[name];
            encodedKey = "object" === typeof encodedKey && null !== encodedKey ? describeObjectForErrorMessage(encodedKey) : describeValueForErrorMessage(encodedKey);
            name === expandedName ? (objKind = str.length, length = encodedKey.length, str += encodedKey) : str = 10 > encodedKey.length && 40 > str.length + encodedKey.length ? str + encodedKey : str + "...";
        }
        str += "}";
    }
    return void 0 === expandedName ? str : -1 < objKind && 0 < length ? (objectOrArray = " ".repeat(objKind) + "^".repeat(length), "\n  " + str + "\n  " + objectOrArray) : "\n  " + str;
}
var hasOwnProperty = Object.prototype.hasOwnProperty, ObjectPrototype = Object.prototype, stringify = JSON.stringify;
function defaultErrorHandler(error) {
    console.error(error);
}
function RequestInstance(type, model, bundlerConfig, onError, onPostpone, onAllReady, onFatalError, identifierPrefix, temporaryReferences) {
    if (null !== ReactSharedInternalsServer.A && ReactSharedInternalsServer.A !== DefaultAsyncDispatcher) throw Error("Currently React only supports one RSC renderer at a time.");
    ReactSharedInternalsServer.A = DefaultAsyncDispatcher;
    var abortSet = new Set(), pingedTasks = [], hints = new Set();
    this.type = type;
    this.status = 10;
    this.flushScheduled = !1;
    this.destination = this.fatalError = null;
    this.bundlerConfig = bundlerConfig;
    this.cache = new Map();
    this.cacheController = new AbortController();
    this.pendingChunks = this.nextChunkId = 0;
    this.hints = hints;
    this.abortableTasks = abortSet;
    this.pingedTasks = pingedTasks;
    this.completedImportChunks = [];
    this.completedHintChunks = [];
    this.completedRegularChunks = [];
    this.completedErrorChunks = [];
    this.writtenSymbols = new Map();
    this.writtenClientReferences = new Map();
    this.writtenServerReferences = new Map();
    this.writtenObjects = new WeakMap();
    this.temporaryReferences = temporaryReferences;
    this.identifierPrefix = identifierPrefix || "";
    this.identifierCount = 1;
    this.taintCleanupQueue = [];
    this.onError = void 0 === onError ? defaultErrorHandler : onError;
    this.onPostpone = void 0 === onPostpone ? noop : onPostpone;
    this.onAllReady = onAllReady;
    this.onFatalError = onFatalError;
    type = createTask(this, model, null, !1, abortSet);
    pingedTasks.push(type);
}
var currentRequest = null;
function resolveRequest() {
    if (currentRequest) return currentRequest;
    if (supportsRequestStorage) {
        var store = requestStorage.getStore();
        if (store) return store;
    }
    return null;
}
function serializeThenable(request, task, thenable) {
    var newTask = createTask(request, thenable, task.keyPath, task.implicitSlot, request.abortableTasks);
    switch(thenable.status){
        case "fulfilled":
            return newTask.model = thenable.value, pingTask(request, newTask), newTask.id;
        case "rejected":
            return erroredTask(request, newTask, thenable.reason), newTask.id;
        default:
            if (12 === request.status) return request.abortableTasks.delete(newTask), task = request.fatalError, abortTask(newTask), finishAbortedTask(newTask, request, task), newTask.id;
            "string" !== typeof thenable.status && (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            }));
    }
    thenable.then(function(value) {
        newTask.model = value;
        pingTask(request, newTask);
    }, function(reason) {
        0 === newTask.status && (erroredTask(request, newTask, reason), enqueueFlush(request));
    });
    return newTask.id;
}
function serializeReadableStream(request, task, stream) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) streamTask.status = 1, entry = streamTask.id.toString(16) + ":C\n", request.completedRegularChunks.push(stringToChunk(entry)), request.abortableTasks.delete(streamTask), request.cacheController.signal.removeEventListener("abort", abortStream), enqueueFlush(request), callOnAllReadyIfReady(request);
            else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), reader.read().then(progress, error);
            } catch (x$8) {
                error(x$8);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortStream), erroredTask(request, streamTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortStream() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortStream);
            signal = signal.reason;
            erroredTask(request, streamTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var supportsBYOB = stream.supportsBYOB;
    if (void 0 === supportsBYOB) try {
        stream.getReader({
            mode: "byob"
        }).releaseLock(), supportsBYOB = !0;
    } catch (x) {
        supportsBYOB = !1;
    }
    var reader = stream.getReader(), streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (supportsBYOB ? "r" : "R") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortStream);
    reader.read().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function serializeAsyncIterable(request, task, iterable, iterator) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) {
                streamTask.status = 1;
                if (void 0 === entry.value) var endStreamRow = streamTask.id.toString(16) + ":C\n";
                else try {
                    var chunkId = outlineModel(request, entry.value);
                    endStreamRow = streamTask.id.toString(16) + ":C" + stringify(serializeByValueID(chunkId)) + "\n";
                } catch (x) {
                    error(x);
                    return;
                }
                request.completedRegularChunks.push(stringToChunk(endStreamRow));
                request.abortableTasks.delete(streamTask);
                request.cacheController.signal.removeEventListener("abort", abortIterable);
                enqueueFlush(request);
                callOnAllReadyIfReady(request);
            } else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), iterator.next().then(progress, error);
            } catch (x$9) {
                error(x$9);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortIterable), erroredTask(request, streamTask, reason), enqueueFlush(request), "function" === typeof iterator.throw && iterator.throw(reason).then(error, error));
    }
    function abortIterable() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortIterable);
            var reason = signal.reason;
            erroredTask(request, streamTask, signal.reason);
            enqueueFlush(request);
            "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
        }
    }
    iterable = iterable === iterator;
    var streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (iterable ? "x" : "X") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortIterable);
    iterator.next().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function emitHint(request, code, model) {
    model = stringify(model);
    code = stringToChunk(":H" + code + model + "\n");
    request.completedHintChunks.push(code);
    enqueueFlush(request);
}
function readThenable(thenable) {
    if ("fulfilled" === thenable.status) return thenable.value;
    if ("rejected" === thenable.status) throw thenable.reason;
    throw thenable;
}
function createLazyWrapperAroundWakeable(request, task, wakeable) {
    switch(wakeable.status){
        case "fulfilled":
            return wakeable.value;
        case "rejected":
            break;
        default:
            "string" !== typeof wakeable.status && (wakeable.status = "pending", wakeable.then(function(fulfilledValue) {
                "pending" === wakeable.status && (wakeable.status = "fulfilled", wakeable.value = fulfilledValue);
            }, function(error) {
                "pending" === wakeable.status && (wakeable.status = "rejected", wakeable.reason = error);
            }));
    }
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: wakeable,
        _init: readThenable
    };
}
function voidHandler() {}
function processServerComponentReturnValue(request, task, Component, result) {
    if ("object" !== typeof result || null === result || result.$$typeof === CLIENT_REFERENCE_TAG$1) return result;
    if ("function" === typeof result.then) return createLazyWrapperAroundWakeable(request, task, result);
    var iteratorFn = getIteratorFn(result);
    return iteratorFn ? (request = {}, request[Symbol.iterator] = function() {
        return iteratorFn.call(result);
    }, request) : "function" !== typeof result[ASYNC_ITERATOR] || "function" === typeof ReadableStream && result instanceof ReadableStream ? result : (request = {}, request[ASYNC_ITERATOR] = function() {
        return result[ASYNC_ITERATOR]();
    }, request);
}
function renderFunctionComponent(request, task, key, Component, props) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    thenableIndexCounter = 0;
    thenableState = prevThenableState;
    props = Component(props, void 0);
    if (12 === request.status) throw "object" === typeof props && null !== props && "function" === typeof props.then && props.$$typeof !== CLIENT_REFERENCE_TAG$1 && props.then(voidHandler, voidHandler), null;
    props = processServerComponentReturnValue(request, task, Component, props);
    Component = task.keyPath;
    prevThenableState = task.implicitSlot;
    null !== key ? task.keyPath = null === Component ? key : Component + "," + key : null === Component && (task.implicitSlot = !0);
    request = renderModelDestructive(request, task, emptyRoot, "", props);
    task.keyPath = Component;
    task.implicitSlot = prevThenableState;
    return request;
}
function renderFragment(request, task, children) {
    return null !== task.keyPath ? (request = [
        REACT_ELEMENT_TYPE,
        REACT_FRAGMENT_TYPE,
        task.keyPath,
        {
            children: children
        }
    ], task.implicitSlot ? [
        request
    ] : request) : children;
}
var serializedSize = 0;
function deferTask(request, task) {
    task = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    pingTask(request, task);
    return "$L" + task.id.toString(16);
}
function renderElement(request, task, type, key, ref, props) {
    if (null !== ref && void 0 !== ref) throw Error("Refs cannot be used in Server Components, nor passed to Client Components.");
    if ("function" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1 && type.$$typeof !== TEMPORARY_REFERENCE_TAG) return renderFunctionComponent(request, task, key, type, props);
    if (type === REACT_FRAGMENT_TYPE && null === key) return type = task.implicitSlot, null === task.keyPath && (task.implicitSlot = !0), props = renderModelDestructive(request, task, emptyRoot, "", props.children), task.implicitSlot = type, props;
    if (null != type && "object" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1) switch(type.$$typeof){
        case REACT_LAZY_TYPE:
            var init = type._init;
            type = init(type._payload);
            if (12 === request.status) throw null;
            return renderElement(request, task, type, key, ref, props);
        case REACT_FORWARD_REF_TYPE:
            return renderFunctionComponent(request, task, key, type.render, props);
        case REACT_MEMO_TYPE:
            return renderElement(request, task, type.type, key, ref, props);
    }
    request = key;
    key = task.keyPath;
    null === request ? request = key : null !== key && (request = key + "," + request);
    props = [
        REACT_ELEMENT_TYPE,
        type,
        request,
        props
    ];
    task = task.implicitSlot && null !== request ? [
        props
    ] : props;
    return task;
}
function pingTask(request, task) {
    var pingedTasks = request.pingedTasks;
    pingedTasks.push(task);
    1 === pingedTasks.length && (request.flushScheduled = null !== request.destination, 21 === request.type || 10 === request.status ? scheduleMicrotask(function() {
        return performWork(request);
    }) : setTimeout(function() {
        return performWork(request);
    }, 0));
}
function createTask(request, model, keyPath, implicitSlot, abortSet) {
    request.pendingChunks++;
    var id = request.nextChunkId++;
    "object" !== typeof model || null === model || null !== keyPath || implicitSlot || request.writtenObjects.set(model, serializeByValueID(id));
    var task = {
        id: id,
        status: 0,
        model: model,
        keyPath: keyPath,
        implicitSlot: implicitSlot,
        ping: function() {
            return pingTask(request, task);
        },
        toJSON: function(parentPropertyName, value) {
            serializedSize += parentPropertyName.length;
            var prevKeyPath = task.keyPath, prevImplicitSlot = task.implicitSlot;
            try {
                var JSCompiler_inline_result = renderModelDestructive(request, task, this, parentPropertyName, value);
            } catch (thrownValue) {
                if (parentPropertyName = task.model, parentPropertyName = "object" === typeof parentPropertyName && null !== parentPropertyName && (parentPropertyName.$$typeof === REACT_ELEMENT_TYPE || parentPropertyName.$$typeof === REACT_LAZY_TYPE), 12 === request.status) task.status = 3, prevKeyPath = request.fatalError, JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
                else if (value = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue, "object" === typeof value && null !== value && "function" === typeof value.then) {
                    JSCompiler_inline_result = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
                    var ping = JSCompiler_inline_result.ping;
                    value.then(ping, ping);
                    JSCompiler_inline_result.thenableState = getThenableStateAfterSuspending();
                    task.keyPath = prevKeyPath;
                    task.implicitSlot = prevImplicitSlot;
                    JSCompiler_inline_result = parentPropertyName ? "$L" + JSCompiler_inline_result.id.toString(16) : serializeByValueID(JSCompiler_inline_result.id);
                } else task.keyPath = prevKeyPath, task.implicitSlot = prevImplicitSlot, request.pendingChunks++, prevKeyPath = request.nextChunkId++, prevImplicitSlot = logRecoverableError(request, value, task), emitErrorChunk(request, prevKeyPath, prevImplicitSlot), JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
            }
            return JSCompiler_inline_result;
        },
        thenableState: null
    };
    abortSet.add(task);
    return task;
}
function serializeByValueID(id) {
    return "$" + id.toString(16);
}
function encodeReferenceChunk(request, id, reference) {
    request = stringify(reference);
    id = id.toString(16) + ":" + request + "\n";
    return stringToChunk(id);
}
function serializeClientReference(request, parent, parentPropertyName, clientReference) {
    var clientReferenceKey = clientReference.$$id + "#" + clientReference.$$name, writtenClientReferences = request.writtenClientReferences, existingId = writtenClientReferences.get(clientReferenceKey);
    if (void 0 !== existingId) return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + existingId.toString(16) : serializeByValueID(existingId);
    try {
        var JSCompiler_inline_result = clientReference.$$importMap ? [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles,
            clientReference.$$importMap
        ] : [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles
        ];
        request.pendingChunks++;
        var importId = request.nextChunkId++, json = stringify(JSCompiler_inline_result), row = importId.toString(16) + ":I" + json + "\n", processedChunk = stringToChunk(row);
        request.completedImportChunks.push(processedChunk);
        writtenClientReferences.set(clientReferenceKey, importId);
        return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + importId.toString(16) : serializeByValueID(importId);
    } catch (x) {
        return request.pendingChunks++, parent = request.nextChunkId++, parentPropertyName = logRecoverableError(request, x, null), emitErrorChunk(request, parent, parentPropertyName), serializeByValueID(parent);
    }
}
function outlineModel(request, value) {
    value = createTask(request, value, null, !1, request.abortableTasks);
    retryTask(request, value);
    return value.id;
}
function serializeTypedArray(request, tag, typedArray) {
    request.pendingChunks++;
    var bufferId = request.nextChunkId++;
    emitTypedArrayChunk(request, bufferId, tag, typedArray, !1);
    return serializeByValueID(bufferId);
}
function serializeBlob(request, blob) {
    function progress(entry) {
        if (0 === newTask.status) {
            if (entry.done) request.cacheController.signal.removeEventListener("abort", abortBlob), pingTask(request, newTask);
            else return model.push(entry.value), reader.read().then(progress).catch(error);
        }
    }
    function error(reason) {
        0 === newTask.status && (request.cacheController.signal.removeEventListener("abort", abortBlob), erroredTask(request, newTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortBlob() {
        if (0 === newTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortBlob);
            signal = signal.reason;
            erroredTask(request, newTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var model = [
        blob.type
    ], newTask = createTask(request, model, null, !1, request.abortableTasks), reader = blob.stream().getReader();
    request.cacheController.signal.addEventListener("abort", abortBlob);
    reader.read().then(progress).catch(error);
    return "$B" + newTask.id.toString(16);
}
var modelRoot = !1;
function renderModelDestructive(request, task, parent, parentPropertyName, value) {
    task.model = value;
    if (value === REACT_ELEMENT_TYPE) return "$";
    if (null === value) return null;
    if ("object" === typeof value) {
        switch(value.$$typeof){
            case REACT_ELEMENT_TYPE:
                var elementReference = null, writtenObjects = request.writtenObjects;
                if (null === task.keyPath && !task.implicitSlot) {
                    var existingReference = writtenObjects.get(value);
                    if (void 0 !== existingReference) {
                        if (modelRoot === value) modelRoot = null;
                        else return existingReference;
                    } else -1 === parentPropertyName.indexOf(":") && (parent = writtenObjects.get(parent), void 0 !== parent && (elementReference = parent + ":" + parentPropertyName, writtenObjects.set(value, elementReference)));
                }
                if (3200 < serializedSize) return deferTask(request, task);
                parentPropertyName = value.props;
                parent = parentPropertyName.ref;
                request = renderElement(request, task, value.type, value.key, void 0 !== parent ? parent : null, parentPropertyName);
                "object" === typeof request && null !== request && null !== elementReference && (writtenObjects.has(request) || writtenObjects.set(request, elementReference));
                return request;
            case REACT_LAZY_TYPE:
                if (3200 < serializedSize) return deferTask(request, task);
                task.thenableState = null;
                parentPropertyName = value._init;
                value = parentPropertyName(value._payload);
                if (12 === request.status) throw null;
                return renderModelDestructive(request, task, emptyRoot, "", value);
            case REACT_LEGACY_ELEMENT_TYPE:
                throw Error('A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.');
        }
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (void 0 !== request.temporaryReferences && (elementReference = request.temporaryReferences.get(value), void 0 !== elementReference)) return "$T" + elementReference;
        elementReference = request.writtenObjects;
        writtenObjects = elementReference.get(value);
        if ("function" === typeof value.then) {
            if (void 0 !== writtenObjects) {
                if (null !== task.keyPath || task.implicitSlot) return "$@" + serializeThenable(request, task, value).toString(16);
                if (modelRoot === value) modelRoot = null;
                else return writtenObjects;
            }
            request = "$@" + serializeThenable(request, task, value).toString(16);
            elementReference.set(value, request);
            return request;
        }
        if (void 0 !== writtenObjects) {
            if (modelRoot === value) {
                if (writtenObjects !== serializeByValueID(task.id)) return writtenObjects;
                modelRoot = null;
            } else return writtenObjects;
        } else if (-1 === parentPropertyName.indexOf(":") && (writtenObjects = elementReference.get(parent), void 0 !== writtenObjects)) {
            existingReference = parentPropertyName;
            if (isArrayImpl(parent) && parent[0] === REACT_ELEMENT_TYPE) switch(parentPropertyName){
                case "1":
                    existingReference = "type";
                    break;
                case "2":
                    existingReference = "key";
                    break;
                case "3":
                    existingReference = "props";
                    break;
                case "4":
                    existingReference = "_owner";
            }
            elementReference.set(value, writtenObjects + ":" + existingReference);
        }
        if (isArrayImpl(value)) return renderFragment(request, task, value);
        if (value instanceof Map) return value = Array.from(value), "$Q" + outlineModel(request, value).toString(16);
        if (value instanceof Set) return value = Array.from(value), "$W" + outlineModel(request, value).toString(16);
        if ("function" === typeof FormData && value instanceof FormData) return value = Array.from(value.entries()), "$K" + outlineModel(request, value).toString(16);
        if (value instanceof Error) return "$Z";
        if (value instanceof ArrayBuffer) return serializeTypedArray(request, "A", new Uint8Array(value));
        if (value instanceof Int8Array) return serializeTypedArray(request, "O", value);
        if (value instanceof Uint8Array) return serializeTypedArray(request, "o", value);
        if (value instanceof Uint8ClampedArray) return serializeTypedArray(request, "U", value);
        if (value instanceof Int16Array) return serializeTypedArray(request, "S", value);
        if (value instanceof Uint16Array) return serializeTypedArray(request, "s", value);
        if (value instanceof Int32Array) return serializeTypedArray(request, "L", value);
        if (value instanceof Uint32Array) return serializeTypedArray(request, "l", value);
        if (value instanceof Float32Array) return serializeTypedArray(request, "G", value);
        if (value instanceof Float64Array) return serializeTypedArray(request, "g", value);
        if (value instanceof BigInt64Array) return serializeTypedArray(request, "M", value);
        if (value instanceof BigUint64Array) return serializeTypedArray(request, "m", value);
        if (value instanceof DataView) return serializeTypedArray(request, "V", value);
        if ("function" === typeof Blob && value instanceof Blob) return serializeBlob(request, value);
        if (elementReference = getIteratorFn(value)) return parentPropertyName = elementReference.call(value), parentPropertyName === value ? "$i" + outlineModel(request, Array.from(parentPropertyName)).toString(16) : renderFragment(request, task, Array.from(parentPropertyName));
        if ("function" === typeof ReadableStream && value instanceof ReadableStream) return serializeReadableStream(request, task, value);
        elementReference = value[ASYNC_ITERATOR];
        if ("function" === typeof elementReference) return null !== task.keyPath ? (request = [
            REACT_ELEMENT_TYPE,
            REACT_FRAGMENT_TYPE,
            task.keyPath,
            {
                children: value
            }
        ], request = task.implicitSlot ? [
            request
        ] : request) : (parentPropertyName = elementReference.call(value), request = serializeAsyncIterable(request, task, value, parentPropertyName)), request;
        if (value instanceof Date) return "$D" + value.toJSON();
        request = getPrototypeOf(value);
        if (request !== ObjectPrototype && (null === request || null !== getPrototypeOf(request))) throw Error("Only plain objects, and a few built-ins, can be passed to Client Components from Server Components. Classes or null prototypes are not supported." + describeObjectForErrorMessage(parent, parentPropertyName));
        return value;
    }
    if ("string" === typeof value) {
        serializedSize += value.length;
        if ("Z" === value[value.length - 1] && parent[parentPropertyName] instanceof Date) return "$D" + value;
        if (1024 <= value.length && null !== byteLengthOfChunk) return request.pendingChunks++, task = request.nextChunkId++, emitTextChunk(request, task, value, !1), serializeByValueID(task);
        request = "$" === value[0] ? "$" + value : value;
        return request;
    }
    if ("boolean" === typeof value) return value;
    if ("number" === typeof value) return Number.isFinite(value) ? 0 === value && -Infinity === 1 / value ? "$-0" : value : Infinity === value ? "$Infinity" : -Infinity === value ? "$-Infinity" : "$NaN";
    if ("undefined" === typeof value) return "$undefined";
    if ("function" === typeof value) {
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (value.$$typeof === SERVER_REFERENCE_TAG) return task = request.writtenServerReferences, parentPropertyName = task.get(value), void 0 !== parentPropertyName ? request = "$F" + parentPropertyName.toString(16) : (parentPropertyName = value.$$bound, parentPropertyName = null === parentPropertyName ? null : Promise.resolve(parentPropertyName), request = outlineModel(request, {
            id: value.$$id,
            bound: parentPropertyName
        }), task.set(value, request), request = "$F" + request.toString(16)), request;
        if (void 0 !== request.temporaryReferences && (request = request.temporaryReferences.get(value), void 0 !== request)) return "$T" + request;
        if (value.$$typeof === TEMPORARY_REFERENCE_TAG) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
        if (/^on[A-Z]/.test(parentPropertyName)) throw Error("Event handlers cannot be passed to Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName) + "\nIf you need interactivity, consider converting part of this to a Client Component.");
        throw Error('Functions cannot be passed directly to Client Components unless you explicitly expose it by marking it with "use server". Or maybe you meant to call this function rather than return it.' + describeObjectForErrorMessage(parent, parentPropertyName));
    }
    if ("symbol" === typeof value) {
        task = request.writtenSymbols;
        elementReference = task.get(value);
        if (void 0 !== elementReference) return serializeByValueID(elementReference);
        elementReference = value.description;
        if (Symbol.for(elementReference) !== value) throw Error("Only global symbols received from Symbol.for(...) can be passed to Client Components. The symbol Symbol.for(" + (value.description + ") cannot be found among global symbols.") + describeObjectForErrorMessage(parent, parentPropertyName));
        request.pendingChunks++;
        parentPropertyName = request.nextChunkId++;
        parent = encodeReferenceChunk(request, parentPropertyName, "$S" + elementReference);
        request.completedImportChunks.push(parent);
        task.set(value, parentPropertyName);
        return serializeByValueID(parentPropertyName);
    }
    if ("bigint" === typeof value) return "$n" + value.toString(10);
    throw Error("Type " + typeof value + " is not supported in Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName));
}
function logRecoverableError(request, error) {
    var prevRequest = currentRequest;
    currentRequest = null;
    try {
        var onError = request.onError;
        var errorDigest = supportsRequestStorage ? requestStorage.run(void 0, onError, error) : onError(error);
    } finally{
        currentRequest = prevRequest;
    }
    if (null != errorDigest && "string" !== typeof errorDigest) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
    return errorDigest || "";
}
function fatalError(request, error) {
    var onFatalError = request.onFatalError;
    onFatalError(error);
    null !== request.destination ? (request.status = 14, closeWithError(request.destination, error)) : (request.status = 13, request.fatalError = error);
    request.cacheController.abort(Error("The render was aborted due to a fatal error.", {
        cause: error
    }));
}
function emitErrorChunk(request, id, digest) {
    digest = {
        digest: digest
    };
    id = id.toString(16) + ":E" + stringify(digest) + "\n";
    id = stringToChunk(id);
    request.completedErrorChunks.push(id);
}
function emitModelChunk(request, id, json) {
    id = id.toString(16) + ":" + json + "\n";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id);
}
function emitTypedArrayChunk(request, id, tag, typedArray, debug) {
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    debug = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
    typedArray = 2048 < typedArray.byteLength ? debug.slice() : debug;
    debug = typedArray.byteLength;
    id = id.toString(16) + ":" + tag + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, typedArray);
}
function emitTextChunk(request, id, text, debug) {
    if (null === byteLengthOfChunk) throw Error("Existence of byteLengthOfChunk should have already been checked. This is a bug in React.");
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    text = stringToChunk(text);
    debug = text.byteLength;
    id = id.toString(16) + ":T" + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, text);
}
function emitChunk(request, task, value) {
    var id = task.id;
    "string" === typeof value && null !== byteLengthOfChunk ? emitTextChunk(request, id, value, !1) : value instanceof ArrayBuffer ? emitTypedArrayChunk(request, id, "A", new Uint8Array(value), !1) : value instanceof Int8Array ? emitTypedArrayChunk(request, id, "O", value, !1) : value instanceof Uint8Array ? emitTypedArrayChunk(request, id, "o", value, !1) : value instanceof Uint8ClampedArray ? emitTypedArrayChunk(request, id, "U", value, !1) : value instanceof Int16Array ? emitTypedArrayChunk(request, id, "S", value, !1) : value instanceof Uint16Array ? emitTypedArrayChunk(request, id, "s", value, !1) : value instanceof Int32Array ? emitTypedArrayChunk(request, id, "L", value, !1) : value instanceof Uint32Array ? emitTypedArrayChunk(request, id, "l", value, !1) : value instanceof Float32Array ? emitTypedArrayChunk(request, id, "G", value, !1) : value instanceof Float64Array ? emitTypedArrayChunk(request, id, "g", value, !1) : value instanceof BigInt64Array ? emitTypedArrayChunk(request, id, "M", value, !1) : value instanceof BigUint64Array ? emitTypedArrayChunk(request, id, "m", value, !1) : value instanceof DataView ? emitTypedArrayChunk(request, id, "V", value, !1) : (value = stringify(value, task.toJSON), emitModelChunk(request, task.id, value));
}
function erroredTask(request, task, error) {
    task.status = 4;
    error = logRecoverableError(request, error, task);
    emitErrorChunk(request, task.id, error);
    request.abortableTasks.delete(task);
    callOnAllReadyIfReady(request);
}
var emptyRoot = {};
function retryTask(request, task) {
    if (0 === task.status) {
        task.status = 5;
        var parentSerializedSize = serializedSize;
        try {
            modelRoot = task.model;
            var resolvedModel = renderModelDestructive(request, task, emptyRoot, "", task.model);
            modelRoot = resolvedModel;
            task.keyPath = null;
            task.implicitSlot = !1;
            if ("object" === typeof resolvedModel && null !== resolvedModel) request.writtenObjects.set(resolvedModel, serializeByValueID(task.id)), emitChunk(request, task, resolvedModel);
            else {
                var json = stringify(resolvedModel);
                emitModelChunk(request, task.id, json);
            }
            task.status = 1;
            request.abortableTasks.delete(task);
            callOnAllReadyIfReady(request);
        } catch (thrownValue) {
            if (12 === request.status) {
                request.abortableTasks.delete(task);
                task.status = 0;
                var errorId = request.fatalError;
                abortTask(task);
                finishAbortedTask(task, request, errorId);
            } else {
                var x = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue;
                if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                    task.status = 0;
                    task.thenableState = getThenableStateAfterSuspending();
                    var ping = task.ping;
                    x.then(ping, ping);
                } else erroredTask(request, task, x);
            }
        } finally{
            serializedSize = parentSerializedSize;
        }
    }
}
function tryStreamTask(request, task) {
    var parentSerializedSize = serializedSize;
    try {
        emitChunk(request, task, task.model);
    } finally{
        serializedSize = parentSerializedSize;
    }
}
function performWork(request) {
    var prevDispatcher = ReactSharedInternalsServer.H;
    ReactSharedInternalsServer.H = HooksDispatcher;
    var prevRequest = currentRequest;
    currentRequest$1 = currentRequest = request;
    try {
        var pingedTasks = request.pingedTasks;
        request.pingedTasks = [];
        for(var i = 0; i < pingedTasks.length; i++)retryTask(request, pingedTasks[i]);
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    } finally{
        ReactSharedInternalsServer.H = prevDispatcher, currentRequest$1 = null, currentRequest = prevRequest;
    }
}
function abortTask(task) {
    0 === task.status && (task.status = 3);
}
function finishAbortedTask(task, request, errorId) {
    3 === task.status && (errorId = serializeByValueID(errorId), task = encodeReferenceChunk(request, task.id, errorId), request.completedErrorChunks.push(task));
}
function flushCompletedChunks(request) {
    var destination = request.destination;
    if (null !== destination) {
        currentView = new Uint8Array(2048);
        writtenBytes = 0;
        try {
            for(var importsChunks = request.completedImportChunks, i = 0; i < importsChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, importsChunks[i]);
            importsChunks.splice(0, i);
            var hintChunks = request.completedHintChunks;
            for(i = 0; i < hintChunks.length; i++)writeChunkAndReturn(destination, hintChunks[i]);
            hintChunks.splice(0, i);
            var regularChunks = request.completedRegularChunks;
            for(i = 0; i < regularChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, regularChunks[i]);
            regularChunks.splice(0, i);
            var errorChunks = request.completedErrorChunks;
            for(i = 0; i < errorChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, errorChunks[i]);
            errorChunks.splice(0, i);
        } finally{
            request.flushScheduled = !1, currentView && 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = null, writtenBytes = 0);
        }
    }
    0 === request.pendingChunks && (12 > request.status && request.cacheController.abort(Error("This render completed successfully. All cacheSignals are now aborted to allow clean up of any unused resources.")), null !== request.destination && (request.status = 14, request.destination.close(), request.destination = null));
}
function startWork(request) {
    request.flushScheduled = null !== request.destination;
    supportsRequestStorage ? scheduleMicrotask(function() {
        requestStorage.run(request, performWork, request);
    }) : scheduleMicrotask(function() {
        return performWork(request);
    });
    setTimeout(function() {
        10 === request.status && (request.status = 11);
    }, 0);
}
function enqueueFlush(request) {
    !1 === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination && (request.flushScheduled = !0, setTimeout(function() {
        request.flushScheduled = !1;
        flushCompletedChunks(request);
    }, 0));
}
function callOnAllReadyIfReady(request) {
    0 === request.abortableTasks.size && (request = request.onAllReady, request());
}
function startFlowing(request, destination) {
    if (13 === request.status) request.status = 14, closeWithError(destination, request.fatalError);
    else if (14 !== request.status && null === request.destination) {
        request.destination = destination;
        try {
            flushCompletedChunks(request);
        } catch (error) {
            logRecoverableError(request, error, null), fatalError(request, error);
        }
    }
}
function finishAbort(request, abortedTasks, errorId) {
    try {
        abortedTasks.forEach(function(task) {
            return finishAbortedTask(task, request, errorId);
        });
        var onAllReady = request.onAllReady;
        onAllReady();
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    }
}
function abort(request, reason) {
    if (!(11 < request.status)) try {
        request.status = 12;
        request.cacheController.abort(reason);
        var abortableTasks = request.abortableTasks;
        if (0 < abortableTasks.size) {
            var error = void 0 === reason ? Error("The render was aborted by the server without a reason.") : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error("The render was aborted by the server with a promise.") : reason, digest = logRecoverableError(request, error, null), errorId = request.nextChunkId++;
            request.fatalError = errorId;
            request.pendingChunks++;
            emitErrorChunk(request, errorId, digest, error, !1);
            abortableTasks.forEach(function(task) {
                return abortTask(task, request, errorId);
            });
            setTimeout(function() {
                return finishAbort(request, abortableTasks, errorId);
            }, 0);
        } else {
            var onAllReady = request.onAllReady;
            onAllReady();
            flushCompletedChunks(request);
        }
    } catch (error$23) {
        logRecoverableError(request, error$23, null), fatalError(request, error$23);
    }
}
function Chunk(status, value, reason, response) {
    this.status = status;
    this.value = value;
    this.reason = reason;
    this._response = response;
}
Chunk.prototype = Object.create(Promise.prototype);
Chunk.prototype.then = function(resolve, reject) {
    switch(this.status){
        case "resolved_model":
            initializeModelChunk(this);
    }
    switch(this.status){
        case "fulfilled":
            resolve(this.value);
            break;
        case "pending":
        case "blocked":
        case "cyclic":
            resolve && (null === this.value && (this.value = []), this.value.push(resolve));
            reject && (null === this.reason && (this.reason = []), this.reason.push(reject));
            break;
        default:
            reject(this.reason);
    }
};
function createPendingChunk(response) {
    return new Chunk("pending", null, null, response);
}
function wakeChunk(listeners, value) {
    for(var i = 0; i < listeners.length; i++)(0, listeners[i])(value);
}
function triggerErrorOnChunk(chunk, error) {
    if ("pending" !== chunk.status && "blocked" !== chunk.status) chunk.reason.error(error);
    else {
        var listeners = chunk.reason;
        chunk.status = "rejected";
        chunk.reason = error;
        null !== listeners && wakeChunk(listeners, error);
    }
}
function resolveModelChunk(chunk, value, id) {
    if ("pending" !== chunk.status) chunk = chunk.reason, "C" === value[0] ? chunk.close("C" === value ? '"$undefined"' : value.slice(1)) : chunk.enqueueModel(value);
    else {
        var resolveListeners = chunk.value, rejectListeners = chunk.reason;
        chunk.status = "resolved_model";
        chunk.value = value;
        chunk.reason = id;
        if (null !== resolveListeners) switch(initializeModelChunk(chunk), chunk.status){
            case "fulfilled":
                wakeChunk(resolveListeners, chunk.value);
                break;
            case "pending":
            case "blocked":
            case "cyclic":
                if (chunk.value) for(value = 0; value < resolveListeners.length; value++)chunk.value.push(resolveListeners[value]);
                else chunk.value = resolveListeners;
                if (chunk.reason) {
                    if (rejectListeners) for(value = 0; value < rejectListeners.length; value++)chunk.reason.push(rejectListeners[value]);
                } else chunk.reason = rejectListeners;
                break;
            case "rejected":
                rejectListeners && wakeChunk(rejectListeners, chunk.reason);
        }
    }
}
function createResolvedIteratorResultChunk(response, value, done) {
    return new Chunk("resolved_model", (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1, response);
}
function resolveIteratorResultChunk(chunk, value, done) {
    resolveModelChunk(chunk, (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1);
}
function loadServerReference$1(response, id, bound, parentChunk, parentObject, key) {
    var serverReference = resolveServerReference(response._bundlerConfig, id);
    id = preloadModule$1(serverReference);
    if (bound) bound = Promise.all([
        bound,
        id
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    });
    else if (id) bound = Promise.resolve(id).then(function() {
        return requireModule(serverReference);
    });
    else return requireModule(serverReference);
    bound.then(createModelResolver(parentChunk, parentObject, key, !1, response, createModel, []), createModelReject(parentChunk));
    return null;
}
function reviveModel(response, parentObj, parentKey, value, reference) {
    if ("string" === typeof value) return parseModelString(response, parentObj, parentKey, value, reference);
    if ("object" === typeof value && null !== value) {
        if (void 0 !== reference && void 0 !== response._temporaryReferences && response._temporaryReferences.set(value, reference), Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = reviveModel(response, value, "" + i, value[i], void 0 !== reference ? reference + ":" + i : void 0);
        else for(i in value)hasOwnProperty.call(value, i) && (parentObj = void 0 !== reference && -1 === i.indexOf(":") ? reference + ":" + i : void 0, parentObj = reviveModel(response, value, i, value[i], parentObj), void 0 !== parentObj ? value[i] = parentObj : delete value[i]);
    }
    return value;
}
var initializingChunk = null, initializingChunkBlockedModel = null;
function initializeModelChunk(chunk) {
    var prevChunk = initializingChunk, prevBlocked = initializingChunkBlockedModel;
    initializingChunk = chunk;
    initializingChunkBlockedModel = null;
    var rootReference = -1 === chunk.reason ? void 0 : chunk.reason.toString(16), resolvedModel = chunk.value;
    chunk.status = "cyclic";
    chunk.value = null;
    chunk.reason = null;
    try {
        var rawModel = JSON.parse(resolvedModel), value = reviveModel(chunk._response, {
            "": rawModel
        }, "", rawModel, rootReference);
        if (null !== initializingChunkBlockedModel && 0 < initializingChunkBlockedModel.deps) initializingChunkBlockedModel.value = value, chunk.status = "blocked";
        else {
            var resolveListeners = chunk.value;
            chunk.status = "fulfilled";
            chunk.value = value;
            null !== resolveListeners && wakeChunk(resolveListeners, value);
        }
    } catch (error) {
        chunk.status = "rejected", chunk.reason = error;
    } finally{
        initializingChunk = prevChunk, initializingChunkBlockedModel = prevBlocked;
    }
}
function reportGlobalError(response, error) {
    response._closed = !0;
    response._closedReason = error;
    response._chunks.forEach(function(chunk) {
        "pending" === chunk.status && triggerErrorOnChunk(chunk, error);
    });
}
function getChunk(response, id) {
    var chunks = response._chunks, chunk = chunks.get(id);
    chunk || (chunk = response._formData.get(response._prefix + id), chunk = null != chunk ? new Chunk("resolved_model", chunk, id, response) : response._closed ? new Chunk("rejected", null, response._closedReason, response) : createPendingChunk(response), chunks.set(id, chunk));
    return chunk;
}
function createModelResolver(chunk, parentObject, key, cyclic, response, map, path) {
    if (initializingChunkBlockedModel) {
        var blocked = initializingChunkBlockedModel;
        cyclic || blocked.deps++;
    } else blocked = initializingChunkBlockedModel = {
        deps: cyclic ? 0 : 1,
        value: null
    };
    return function(value) {
        for(var i = 1; i < path.length; i++)value = value[path[i]];
        parentObject[key] = map(response, value);
        "" === key && null === blocked.value && (blocked.value = parentObject[key]);
        blocked.deps--;
        0 === blocked.deps && "blocked" === chunk.status && (value = chunk.value, chunk.status = "fulfilled", chunk.value = blocked.value, null !== value && wakeChunk(value, blocked.value));
    };
}
function createModelReject(chunk) {
    return function(error) {
        return triggerErrorOnChunk(chunk, error);
    };
}
function getOutlinedModel(response, reference, parentObject, key, map) {
    reference = reference.split(":");
    var id = parseInt(reference[0], 16);
    id = getChunk(response, id);
    switch(id.status){
        case "resolved_model":
            initializeModelChunk(id);
    }
    switch(id.status){
        case "fulfilled":
            parentObject = id.value;
            for(key = 1; key < reference.length; key++)parentObject = parentObject[reference[key]];
            return map(response, parentObject);
        case "pending":
        case "blocked":
        case "cyclic":
            var parentChunk = initializingChunk;
            id.then(createModelResolver(parentChunk, parentObject, key, "cyclic" === id.status, response, map, reference), createModelReject(parentChunk));
            return null;
        default:
            throw id.reason;
    }
}
function createMap(response, model) {
    return new Map(model);
}
function createSet(response, model) {
    return new Set(model);
}
function extractIterator(response, model) {
    return model[Symbol.iterator]();
}
function createModel(response, model) {
    return model;
}
function parseTypedArray(response, reference, constructor, bytesPerElement, parentObject, parentKey) {
    reference = parseInt(reference.slice(2), 16);
    reference = response._formData.get(response._prefix + reference);
    reference = constructor === ArrayBuffer ? reference.arrayBuffer() : reference.arrayBuffer().then(function(buffer) {
        return new constructor(buffer);
    });
    bytesPerElement = initializingChunk;
    reference.then(createModelResolver(bytesPerElement, parentObject, parentKey, !1, response, createModel, []), createModelReject(bytesPerElement));
    return null;
}
function resolveStream(response, id, stream, controller) {
    var chunks = response._chunks;
    stream = new Chunk("fulfilled", stream, controller, response);
    chunks.set(id, stream);
    response = response._formData.getAll(response._prefix + id);
    for(id = 0; id < response.length; id++)chunks = response[id], "C" === chunks[0] ? controller.close("C" === chunks ? '"$undefined"' : chunks.slice(1)) : controller.enqueueModel(chunks);
}
function parseReadableStream(response, reference, type) {
    reference = parseInt(reference.slice(2), 16);
    var controller = null;
    type = new ReadableStream({
        type: type,
        start: function(c) {
            controller = c;
        }
    });
    var previousBlockedChunk = null;
    resolveStream(response, reference, type, {
        enqueueModel: function(json) {
            if (null === previousBlockedChunk) {
                var chunk = new Chunk("resolved_model", json, -1, response);
                initializeModelChunk(chunk);
                "fulfilled" === chunk.status ? controller.enqueue(chunk.value) : (chunk.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                }), previousBlockedChunk = chunk);
            } else {
                chunk = previousBlockedChunk;
                var chunk$26 = createPendingChunk(response);
                chunk$26.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                });
                previousBlockedChunk = chunk$26;
                chunk.then(function() {
                    previousBlockedChunk === chunk$26 && (previousBlockedChunk = null);
                    resolveModelChunk(chunk$26, json, -1);
                });
            }
        },
        close: function() {
            if (null === previousBlockedChunk) controller.close();
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.close();
                });
            }
        },
        error: function(error) {
            if (null === previousBlockedChunk) controller.error(error);
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.error(error);
                });
            }
        }
    });
    return type;
}
function asyncIterator() {
    return this;
}
function createIterator(next) {
    next = {
        next: next
    };
    next[ASYNC_ITERATOR] = asyncIterator;
    return next;
}
function parseAsyncIterable(response, reference, iterator) {
    reference = parseInt(reference.slice(2), 16);
    var buffer = [], closed = !1, nextWriteIndex = 0, $jscomp$compprop2 = {};
    $jscomp$compprop2 = ($jscomp$compprop2[ASYNC_ITERATOR] = function() {
        var nextReadIndex = 0;
        return createIterator(function(arg) {
            if (void 0 !== arg) throw Error("Values cannot be passed to next() of AsyncIterables passed to Client Components.");
            if (nextReadIndex === buffer.length) {
                if (closed) return new Chunk("fulfilled", {
                    done: !0,
                    value: void 0
                }, null, response);
                buffer[nextReadIndex] = createPendingChunk(response);
            }
            return buffer[nextReadIndex++];
        });
    }, $jscomp$compprop2);
    iterator = iterator ? $jscomp$compprop2[ASYNC_ITERATOR]() : $jscomp$compprop2;
    resolveStream(response, reference, iterator, {
        enqueueModel: function(value) {
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !1) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !1);
            nextWriteIndex++;
        },
        close: function(value) {
            closed = !0;
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !0) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !0);
            for(nextWriteIndex++; nextWriteIndex < buffer.length;)resolveIteratorResultChunk(buffer[nextWriteIndex++], '"$undefined"', !0);
        },
        error: function(error) {
            closed = !0;
            for(nextWriteIndex === buffer.length && (buffer[nextWriteIndex] = createPendingChunk(response)); nextWriteIndex < buffer.length;)triggerErrorOnChunk(buffer[nextWriteIndex++], error);
        }
    });
    return iterator;
}
function parseModelString(response, obj, key, value, reference) {
    if ("$" === value[0]) {
        switch(value[1]){
            case "$":
                return value.slice(1);
            case "@":
                return obj = parseInt(value.slice(2), 16), getChunk(response, obj);
            case "F":
                return value = value.slice(2), value = getOutlinedModel(response, value, obj, key, createModel), loadServerReference$1(response, value.id, value.bound, initializingChunk, obj, key);
            case "T":
                if (void 0 === reference || void 0 === response._temporaryReferences) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
                return createTemporaryReference(response._temporaryReferences, reference);
            case "Q":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createMap);
            case "W":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createSet);
            case "K":
                obj = value.slice(2);
                var formPrefix = response._prefix + obj + "_", data = new FormData();
                response._formData.forEach(function(entry, entryKey) {
                    entryKey.startsWith(formPrefix) && data.append(entryKey.slice(formPrefix.length), entry);
                });
                return data;
            case "i":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, extractIterator);
            case "I":
                return Infinity;
            case "-":
                return "$-0" === value ? -0 : -Infinity;
            case "N":
                return NaN;
            case "u":
                return;
            case "D":
                return new Date(Date.parse(value.slice(2)));
            case "n":
                return BigInt(value.slice(2));
        }
        switch(value[1]){
            case "A":
                return parseTypedArray(response, value, ArrayBuffer, 1, obj, key);
            case "O":
                return parseTypedArray(response, value, Int8Array, 1, obj, key);
            case "o":
                return parseTypedArray(response, value, Uint8Array, 1, obj, key);
            case "U":
                return parseTypedArray(response, value, Uint8ClampedArray, 1, obj, key);
            case "S":
                return parseTypedArray(response, value, Int16Array, 2, obj, key);
            case "s":
                return parseTypedArray(response, value, Uint16Array, 2, obj, key);
            case "L":
                return parseTypedArray(response, value, Int32Array, 4, obj, key);
            case "l":
                return parseTypedArray(response, value, Uint32Array, 4, obj, key);
            case "G":
                return parseTypedArray(response, value, Float32Array, 4, obj, key);
            case "g":
                return parseTypedArray(response, value, Float64Array, 8, obj, key);
            case "M":
                return parseTypedArray(response, value, BigInt64Array, 8, obj, key);
            case "m":
                return parseTypedArray(response, value, BigUint64Array, 8, obj, key);
            case "V":
                return parseTypedArray(response, value, DataView, 1, obj, key);
            case "B":
                return obj = parseInt(value.slice(2), 16), response._formData.get(response._prefix + obj);
        }
        switch(value[1]){
            case "R":
                return parseReadableStream(response, value, void 0);
            case "r":
                return parseReadableStream(response, value, "bytes");
            case "X":
                return parseAsyncIterable(response, value, !1);
            case "x":
                return parseAsyncIterable(response, value, !0);
        }
        value = value.slice(1);
        return getOutlinedModel(response, value, obj, key, createModel);
    }
    return value;
}
function createResponse(bundlerConfig, formFieldPrefix, temporaryReferences) {
    var backingFormData = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : new FormData(), chunks = new Map();
    return {
        _bundlerConfig: bundlerConfig,
        _prefix: formFieldPrefix,
        _formData: backingFormData,
        _chunks: chunks,
        _closed: !1,
        _closedReason: null,
        _temporaryReferences: temporaryReferences
    };
}
function close(response) {
    reportGlobalError(response, Error("Connection closed."));
}
function loadServerReference(bundlerConfig, id, bound) {
    var serverReference = resolveServerReference(bundlerConfig, id);
    bundlerConfig = preloadModule$1(serverReference);
    return bound ? Promise.all([
        bound,
        bundlerConfig
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    }) : bundlerConfig ? Promise.resolve(bundlerConfig).then(function() {
        return requireModule(serverReference);
    }) : Promise.resolve(requireModule(serverReference));
}
function decodeBoundActionMetaData(body, serverManifest, formFieldPrefix) {
    body = createResponse(serverManifest, formFieldPrefix, void 0, body);
    close(body);
    body = getChunk(body, 0);
    body.then(function() {});
    if ("fulfilled" !== body.status) throw body.reason;
    return body.value;
}
function decodeAction$1(body, serverManifest) {
    var formData = new FormData(), action = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_") ? key.startsWith("$ACTION_REF_") ? (value = "$ACTION_" + key.slice(12) + ":", value = decodeBoundActionMetaData(body, serverManifest, value), action = loadServerReference(serverManifest, value.id, value.bound)) : key.startsWith("$ACTION_ID_") && (value = key.slice(11), action = loadServerReference(serverManifest, value, null)) : formData.append(key, value);
    });
    return null === action ? null : action.then(function(fn) {
        return fn.bind(null, formData);
    });
}
function decodeFormState$1(actionResult, body, serverManifest) {
    var keyPath = body.get("$ACTION_KEY");
    if ("string" !== typeof keyPath) return Promise.resolve(null);
    var metaData = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_REF_") && (value = "$ACTION_" + key.slice(12) + ":", metaData = decodeBoundActionMetaData(body, serverManifest, value));
    });
    if (null === metaData) return Promise.resolve(null);
    var referenceId = metaData.id;
    return Promise.resolve(metaData.bound).then(function(bound) {
        return null === bound ? null : [
            actionResult,
            keyPath,
            referenceId,
            bound.length - 1
        ];
    });
}
var serverManifest = {};
exports.createClientReference = function(id, exportName, bundles, importMap) {
    return {
        $$typeof: CLIENT_REFERENCE_TAG$1,
        $$id: id,
        $$name: exportName,
        $$bundles: bundles,
        $$importMap: importMap
    };
};
exports.createTemporaryReferenceSet = function() {
    return new WeakMap();
};
exports.decodeAction = function(body) {
    return decodeAction$1(body, serverManifest);
};
exports.decodeFormState = function(actionResult, body) {
    return decodeFormState$1(actionResult, body, serverManifest);
};
exports.decodeReply = function(body, options) {
    if ("string" === typeof body) {
        var form = new FormData();
        form.append("0", body);
        body = form;
    }
    body = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0, body);
    options = getChunk(body, 0);
    close(body);
    return options;
};
exports.decodeReplyFromAsyncIterable = function(iterable, options) {
    function progress(entry) {
        if (entry.done) close(response);
        else {
            entry = entry.value;
            var name = entry[0];
            entry = entry[1];
            if ("string" === typeof entry) {
                response._formData.append(name, entry);
                var prefix = response._prefix;
                if (name.startsWith(prefix)) {
                    var chunks = response._chunks;
                    name = +name.slice(prefix.length);
                    (chunks = chunks.get(name)) && resolveModelChunk(chunks, entry, name);
                }
            } else response._formData.append(name, entry);
            iterator.next().then(progress, error);
        }
    }
    function error(reason) {
        reportGlobalError(response, reason);
        "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
    }
    var iterator = iterable[ASYNC_ITERATOR](), response = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0);
    iterator.next().then(progress, error);
    return getChunk(response, 0);
};
exports.loadServerAction = function(id) {
    var reference = resolveServerReference(serverManifest, id);
    return Promise.resolve(reference).then(function() {
        return preloadModule$1(reference);
    }).then(function() {
        var fn = requireModule(reference);
        if ("function" !== typeof fn) throw Error("Server actions must be functions");
        return fn;
    });
};
exports.registerServerActions = function(manifest) {
    serverManifest = manifest;
};
exports.registerServerReference = function(reference, id, exportName) {
    return Object.defineProperties(reference, {
        $$typeof: {
            value: SERVER_REFERENCE_TAG
        },
        $$id: {
            value: id + "#" + exportName,
            configurable: !0
        },
        $$bound: {
            value: null,
            configurable: !0
        },
        bind: {
            value: bind,
            configurable: !0
        }
    });
};
exports.renderToReadableStream = function(model, options) {
    var request = new RequestInstance(20, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, noop, noop, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
    if (options && options.signal) {
        var signal = options.signal;
        if (signal.aborted) abort(request, signal.reason);
        else {
            var listener = function() {
                abort(request, signal.reason);
                signal.removeEventListener("abort", listener);
            };
            signal.addEventListener("abort", listener);
        }
    }
    return new ReadableStream({
        type: "bytes",
        start: function() {
            startWork(request);
        },
        pull: function(controller) {
            startFlowing(request, controller);
        },
        cancel: function(reason) {
            request.destination = null;
            abort(request, reason);
        }
    }, {
        highWaterMark: 0
    });
};
exports.unstable_prerender = function(model, options) {
    return new Promise(function(resolve, reject) {
        var request = new RequestInstance(21, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, function() {
            var stream = new ReadableStream({
                type: "bytes",
                pull: function(controller) {
                    startFlowing(request, controller);
                },
                cancel: function(reason) {
                    request.destination = null;
                    abort(request, reason);
                }
            }, {
                highWaterMark: 0
            });
            resolve({
                prelude: stream
            });
        }, reject, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) abort(request, signal.reason);
            else {
                var listener = function() {
                    abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        startWork(request);
    });
};

},{"2381f0f3ff03ff95":"gC2PC","6db66a729b66b575":"a1TxN"}],"gC2PC":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("b657abac8afb5bb8");

},{"b657abac8afb5bb8":"c4Fud"}],"c4Fud":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("6a05e75e64e4f862");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.1.0";

},{"6a05e75e64e4f862":"a1TxN"}],"81MDh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 17H15c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.75c.414 0 .75-.337.75-.75v-6.5c0-.413-.336-.75-.75-.75H15c-.414 0-.75-.336-.75-.75S14.586 6 15 6h1.75C17.99 6 19 7.01 19 8.25v6.5c0 1.24-1.01 2.25-2.25 2.25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 9,
                cy: 7,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 5,
                cy: 10,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 5,
                cy: 7,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.75 3h-7.5C2.01 3 1 4.01 1 5.25v9.5C1 15.99 2.01 17 3.25 17h7.5c1.24 0 2.25-1.01 2.25-2.25v-9.5C13 4.01 11.99 3 10.75 3M8.249 15.5H5.75v-1c0-.413.336-.75.75-.75h.999c.413 0 .75.337.75.75zm3.251-.75c0 .413-.336.75-.75.75H9.749v-1c0-1.24-1.01-2.25-2.25-2.25H6.5c-1.24 0-2.25 1.01-2.25 2.25v1h-1c-.414 0-.75-.337-.75-.75v-9.5c0-.413.336-.75.75-.75h7.5c.414 0 .75.337.75.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 9,
                cy: 10,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 15,
                cy: 10,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 15,
                cy: 13,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kzvDN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.004 12.589c-.888 0-1.753-.46-2.228-1.283-.708-1.228-.286-2.801.94-3.51.593-.343 1.285-.433 1.949-.256.663.178 1.216.604 1.56 1.197.342.594.433 1.286.256 1.949-.178.663-.603 1.216-1.197 1.56-.403.233-.845.343-1.28.343m-.93-2.033c.295.508.949.683 1.46.39.247-.142.424-.373.498-.648s.036-.564-.107-.81c-.143-.248-.373-.425-.649-.499-.275-.073-.563-.035-.81.107-.51.295-.686.949-.391 1.46"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M6.907 18.318c-.34 0-.682-.085-.992-.264l-.82-.473c-.893-.514-1.25-1.65-.811-2.583l.58-1.233q-.398-.546-.672-1.161l-1.357-.113C1.806 12.406 1 11.531 1 10.5v-.946c0-1.033.805-1.91 1.833-1.994l1.354-.115q.138-.313.302-.6.165-.285.37-.564l-.581-1.23c-.441-.932-.087-2.068.807-2.584l.82-.474c.893-.516 2.054-.259 2.643.59l.777 1.118q.667-.074 1.341 0l.775-1.119c.59-.85 1.751-1.11 2.644-.594l.82.473c.894.516 1.25 1.651.81 2.584l-.58 1.232q.399.548.672 1.161l1.357.113c1.028.085 1.834.96 1.835 1.991v.947c.001 1.031-.803 1.907-1.832 1.994l-1.355.115q-.136.313-.303.6-.164.284-.368.563l.58 1.23c.441.93.087 2.067-.806 2.584l-.82.475c-.894.518-2.054.258-2.643-.591l-.778-1.118q-.67.073-1.34 0l-.777 1.12c-.384.555-1.012.857-1.65.857M6.904 3.225q-.13 0-.248.066l-.82.475c-.223.129-.312.412-.202.645l.78 1.65c.125.267.083.583-.108.807-.204.24-.373.477-.517.726q-.212.37-.368.81c-.098.278-.35.472-.644.496l-1.819.154c-.262.022-.458.236-.458.499v.946c0 .258.202.477.459.498l1.82.15c.293.025.546.22.644.498.2.56.497 1.076.887 1.532.192.223.234.54.109.806l-.778 1.653c-.11.233-.02.517.203.645l.82.474c.224.13.514.063.66-.148l1.041-1.502c.168-.242.46-.369.753-.31.588.108 1.184.11 1.77 0 .29-.055.585.066.753.31l1.042 1.499c.147.21.439.276.66.147l.821-.474c.226-.13.314-.409.201-.646l-.779-1.65c-.126-.267-.084-.583.108-.807.204-.24.373-.477.515-.725h.001c.143-.248.263-.512.369-.81.098-.279.35-.473.644-.497l1.819-.153c.256-.022.458-.24.458-.499l-.001-.947c0-.262-.197-.476-.459-.498l-1.819-.15c-.294-.025-.546-.22-.645-.498-.198-.56-.496-1.075-.887-1.532-.191-.224-.234-.54-.108-.806l.777-1.653c.11-.233.02-.517-.203-.646l-.82-.473c-.224-.127-.514-.061-.66.15l-1.04 1.5c-.168.243-.46.368-.753.31-.591-.11-1.188-.11-1.77 0-.292.052-.586-.067-.754-.31L7.316 3.439c-.096-.137-.253-.213-.412-.213"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l7Qgj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _reactAriaComponents = require("react-aria-components");
"use client";
function Example() {
    let { contains } = (0, _reactAriaComponents.useFilter)({
        sensitivity: 'base'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                children: "Add tag..."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Popover), {
                "aria-label": "Select a tag",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Autocomplete), {
                    filter: contains,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SearchField), {
                            "aria-label": "Search tags",
                            autoFocus: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
                            styles: " Jv12",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                    children: "News"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                    children: "Travel"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                    children: "Shopping"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                    children: "Business"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                    children: "Entertainment"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                    children: "Food"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                    children: "Technology"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                    children: "Health"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                    children: "Science"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"mdx-8:0":"bcSCt","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Autocomplete","92IrI"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuTrigger","1F0Yz"],["Popover","62puW"],["SearchField","5lOkR"]],"react-aria-components":"eUaoA","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5lOkR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchFieldContext", ()=>SearchFieldContext);
parcelHelpers.export(exports, "SearchField", ()=>SearchField);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _clearButton = require("./ClearButton");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _field = require("./Field");
var _form = require("./Form");
var _icon = require("./Icon");
var _s2IconSearch20NSvg = require("../s2wf-icons/S2_Icon_Search_20_N.svg");
var _s2IconSearch20NSvgDefault = parcelHelpers.interopDefault(_s2IconSearch20NSvg);
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const SearchFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const SearchField = /*#__PURE__*/ (0, _react.forwardRef)(function SearchField(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, SearchFieldContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { label, description, errorMessage, necessityIndicator, labelPosition = 'top', labelAlign = 'start', UNSAFE_className = '', UNSAFE_style, ...searchFieldProps } = props;
    let domRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    // Expose imperative interface for ref
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SearchField), {
        ...searchFieldProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se12';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU12';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG12';
                }
            }
            if (props.isInForm) rules += ' DLwlgod12';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb12';
                else if (props.labelPosition === "top") rules += ' DM8Mfn12';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb12';
            else if (props.labelPosition === "top") rules += ' E4w1sLc12';
            if (props.labelPosition === "side") rules += ' CbRM95c12';
            else if (props.labelPosition === "top") rules += ' Cxaocre12';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e12';
                rules += ' vx12';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d12';
                rules += ' vx12';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b12';
                rules += ' vx12';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a12';
                rules += ' vx12';
            } else {
                rules += ' -_6BNtrc-c12';
                rules += ' vx12';
            }
            rules += ' ea12';
            rules += ' _Fd12';
            rules += ' _FezxGHba12';
            rules += ' _FnuYUweb12';
            if (props.size === "XL") rules += ' -BhX7R-Fz12';
            else if (props.size === "L") rules += ' -BhX7R-Fv12';
            else if (props.size === "S") rules += ' -BhX7R-Fp12';
            else if (props.size === "XS") rules += ' -BhX7R-Fn12';
            else rules += ' -BhX7R-Fx12';
            rules += ' -AJjOLd-UVkF0Db12';
            rules += ' qg12';
            rules += ' __ca12';
            rules += ' -Qg41Lb-JAxCW0c12';
            if (props.isDisabled) {
                rules += ' pp12';
                rules += ' plc12';
            } else {
                if (props.isPressed) rules += ' po12';
                else if (props.isFocusVisible) rules += ' po12';
                else if (props.isHovered) rules += ' po12';
                else rules += ' pt12';
            }
            return rules;
        }({
            size: props.size,
            labelPosition,
            isInForm: !!formContext
        }, props.styles),
        children: ({ isDisabled, isInvalid, isEmpty })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: props.size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        isDisabled: isDisabled,
                        size: props.size,
                        styles: " og12 ng12 kg12 jg12 Sw12 Rd12",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                                values: [
                                    [
                                        (0, _icon.IconContext),
                                        {
                                            render: (0, _centerBaseline.centerBaseline)({
                                                slot: 'icon',
                                                styles: " _va12 Ht12 Hsu12 -_8sjo0b-t5ZbAob12"
                                            }),
                                            styles: " ZuUmpre12 FuUmpre12 I67logd12"
                                        }
                                    ]
                                ],
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconSearch20NSvgDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {
                                ref: inputRef,
                                UNSAFE_className: "zc3JFe"
                            }),
                            !isEmpty && !searchFieldProps.isReadOnly && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearButton.ClearButton), {
                                size: props.size
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: props.size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        children: errorMessage
                    })
                ]
            })
    });
});

},{"0":"b77Dk","1":"jMp7P","2":"9bOYc","3":"fRszU","4":"28cig","react/jsx-runtime":"2Is6Z","react-aria-components":[["Provider","bA6Cz"],["SearchField","Uk5yj"]],"./CenterBaseline":"1vpL9","./ClearButton":"iQ1Sx","react":"a1TxN","@react-spectrum/utils":"jqfrX","./Field":"eI7CE","./Form":"cHqN4","./Icon":"jQAJE","../s2wf-icons/S2_Icon_Search_20_N.svg":"cSREm","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b77Dk":[function() {},{}],"jMp7P":[function() {},{}],"9bOYc":[function() {},{}],"fRszU":[function() {},{}],"28cig":[function() {},{}],"Uk5yj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchFieldContext", ()=>SearchFieldContext);
parcelHelpers.export(exports, "SearchField", ()=>SearchField);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _utils = require("./utils");
var _collections = require("@react-aria/collections");
var _fieldError = require("./FieldError");
var _rspcontexts = require("./RSPContexts");
var _utils1 = require("@react-aria/utils");
var _form = require("./Form");
var _group = require("./Group");
var _input = require("./Input");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactStately = require("react-stately");
var _text = require("./Text");
const SearchFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const SearchField = /*#__PURE__*/ (0, _collections.createHideableComponent)(function SearchField(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, SearchFieldContext);
    let { validationBehavior: formValidationBehavior } = (0, _utils.useSlottedContext)((0, _form.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let inputRef = (0, _react.useRef)(null);
    [props, inputRef] = (0, _utils.useContextProps)(props, inputRef, (0, _rspcontexts.FieldInputContext));
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let state = (0, _reactStately.useSearchFieldState)({
        ...props,
        validationBehavior
    });
    let { labelProps, inputProps, clearButtonProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useSearchField)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior
    }, state, inputRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isEmpty: state.value === '',
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false,
            state
        },
        defaultClassName: 'react-aria-SearchField'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-empty": state.value === '' || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _button.ButtonContext),
                clearButtonProps
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _group.GroupContext),
                {
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, renderProps.children));
});

},{"react-aria":"2czfR","./Button":"9G5XO","./utils":"bA6Cz","@react-aria/collections":"jY1vZ","./FieldError":"algyu","./RSPContexts":"lIerG","@react-aria/utils":"3upVm","./Form":"g7RKA","./Group":"6UspO","./Input":"jU9y1","./Label":"fjKq6","react":"a1TxN","react-stately":"fG7Zj","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2czfR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a search field.
 * @param props - Props for the search field.
 * @param state - State for the search field, as returned by `useSearchFieldState`.
 * @param inputRef - A ref to the input element.
 */ parcelHelpers.export(exports, "useSearchField", ()=>useSearchField);
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _i18N = require("@react-aria/i18n");
var _textfield = require("@react-aria/textfield");
function useSearchField(props, state, inputRef) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/searchfield');
    let { isDisabled, isReadOnly, onSubmit, onClear, type = 'search' } = props;
    let onKeyDown = (e)=>{
        const key = e.key;
        if (key === 'Enter' && (isDisabled || isReadOnly)) e.preventDefault();
        if (isDisabled || isReadOnly) return;
        // for backward compatibility;
        // otherwise, "Enter" on an input would trigger a form submit, the default browser behavior
        if (key === 'Enter' && onSubmit) {
            e.preventDefault();
            onSubmit(state.value);
        }
        if (key === 'Escape') {
            // Also check the inputRef value for the case where the value was set directly on the input element instead of going through
            // the hook
            if (state.value === '' && (!inputRef.current || inputRef.current.value === '')) e.continuePropagation();
            else {
                e.preventDefault();
                state.setValue('');
                if (onClear) onClear();
            }
        }
    };
    let onClearButtonClick = ()=>{
        state.setValue('');
        if (onClear) onClear();
    };
    let onPressStart = ()=>{
        // this is in PressStart for mobile so that touching the clear button doesn't remove focus from
        // the input and close the keyboard
        inputRef.current?.focus();
    };
    let { labelProps, inputProps, descriptionProps, errorMessageProps, ...validation } = (0, _textfield.useTextField)({
        ...props,
        value: state.value,
        onChange: state.setValue,
        onKeyDown: !isReadOnly ? (0, _utils.chain)(onKeyDown, props.onKeyDown) : props.onKeyDown,
        type
    }, inputRef);
    return {
        labelProps,
        inputProps: {
            ...inputProps,
            // already handled by useSearchFieldState
            defaultValue: undefined
        },
        clearButtonProps: {
            'aria-label': stringFormatter.format('Clear search'),
            excludeFromTabOrder: true,
            preventFocusOnPress: true,
            isDisabled: isDisabled || isReadOnly,
            onPress: onClearButtonClick,
            onPressStart
        },
        descriptionProps,
        errorMessageProps,
        ...validation
    };
}

},{"@react-aria/utils":"ij7eS","../intl/*.json":"9Ekzk","@react-aria/i18n":"7lxyl","@react-aria/textfield":"j6sGd","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Ekzk":[function(require,module,exports,__globalThis) {
const _temp0 = require("ecfc0164cdafbc11");
const _temp1 = require("533820a702a6cc4d");
const _temp2 = require("adc1d07960abb370");
const _temp3 = require("959d90d2e1b8754d");
const _temp4 = require("c7bcb7c68ae4d133");
const _temp5 = require("7592b3baca1e1ab7");
const _temp6 = require("377509ed67276db9");
const _temp7 = require("bcdffd9a74290826");
const _temp8 = require("66f96fbb9c6f57b3");
const _temp9 = require("96660d96c61006f6");
const _temp10 = require("e42562491f0a003a");
const _temp11 = require("b2e319db05a47686");
const _temp12 = require("8c2f9a8959ebc6d8");
const _temp13 = require("5d3c12b049cdb778");
const _temp14 = require("11cc1fb3d7f8c195");
const _temp15 = require("c7097d1ca0fc0d82");
const _temp16 = require("6a0de05d519cdbf5");
const _temp17 = require("9741ebd533b2078c");
const _temp18 = require("406b77d2f3fc3437");
const _temp19 = require("53d9d9bd8feb82b1");
const _temp20 = require("7b20791f74309e10");
const _temp21 = require("d06b6fc5dda02e88");
const _temp22 = require("a28a6945ed983bd6");
const _temp23 = require("ebef8b25fee90b36");
const _temp24 = require("84e709af2309f7d7");
const _temp25 = require("2526519e9c0d0e8b");
const _temp26 = require("441fee45de55b70c");
const _temp27 = require("190818b45cb371e");
const _temp28 = require("929004f2e45d5643");
const _temp29 = require("77e5fd88fe39459e");
const _temp30 = require("bbe929569218677b");
const _temp31 = require("d3b3389f28451bb4");
const _temp32 = require("6b83a28d69d9848f");
const _temp33 = require("7fb75107a926411e");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"ecfc0164cdafbc11":"ctpKo","533820a702a6cc4d":"ctpKo","adc1d07960abb370":"ctpKo","959d90d2e1b8754d":"ctpKo","c7bcb7c68ae4d133":"ctpKo","7592b3baca1e1ab7":"ctpKo","377509ed67276db9":"dIYmL","bcdffd9a74290826":"ctpKo","66f96fbb9c6f57b3":"ctpKo","96660d96c61006f6":"ctpKo","e42562491f0a003a":"ctpKo","b2e319db05a47686":"ctpKo","8c2f9a8959ebc6d8":"ctpKo","5d3c12b049cdb778":"ctpKo","11cc1fb3d7f8c195":"ctpKo","c7097d1ca0fc0d82":"ctpKo","6a0de05d519cdbf5":"ctpKo","9741ebd533b2078c":"ctpKo","406b77d2f3fc3437":"ctpKo","53d9d9bd8feb82b1":"ctpKo","7b20791f74309e10":"ctpKo","d06b6fc5dda02e88":"ctpKo","a28a6945ed983bd6":"ctpKo","ebef8b25fee90b36":"ctpKo","84e709af2309f7d7":"ctpKo","2526519e9c0d0e8b":"ctpKo","441fee45de55b70c":"ctpKo","190818b45cb371e":"ctpKo","929004f2e45d5643":"ctpKo","77e5fd88fe39459e":"ctpKo","bbe929569218677b":"ctpKo","d3b3389f28451bb4":"ctpKo","6b83a28d69d9848f":"ctpKo","7fb75107a926411e":"ctpKo"}],"dIYmL":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Clear search`
};

},{}],"fG7Zj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a search field.
 */ parcelHelpers.export(exports, "useSearchFieldState", ()=>useSearchFieldState);
var _utils = require("@react-stately/utils");
function useSearchFieldState(props) {
    let [value, setValue] = (0, _utils.useControlledState)(toString(props.value), toString(props.defaultValue) || '', props.onChange);
    return {
        value,
        setValue
    };
}
function toString(val) {
    if (val == null) return;
    return val.toString();
}

},{"@react-stately/utils":"4Nj6T","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iQ1Sx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClearButton", ()=>ClearButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _cross = require("../ui-icons/Cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _react = require("react");
var _pressScale = require("./pressScale");
var _utils = require("@react-spectrum/utils");
const focusRingStyles = {
    outlineStyle: {
        "default": "none",
        isFocusVisible: "solid"
    },
    outlineColor: "focus-ring",
    outlineWidth: 2,
    outlineOffset: 2
};
const visibleClearButton = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    if (props.isStaticColor) rules += ' Ok12';
    else rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kc12';
    rules += ' sd12';
    rules += ' eb12';
    rules += ' _Ca12';
    rules += ' Fb12';
    if (props.size === "XL") rules += ' ZF12';
    else if (props.size === "L") rules += ' Zw12';
    else if (props.size === "S") rules += ' Zo12';
    else if (props.size === "XS") rules += ' Zm12';
    else rules += ' ZC12';
    rules += ' _va12';
    rules += ' og12';
    rules += ' ng12';
    rules += ' kg12';
    rules += ' jg12';
    rules += ' _je12';
    rules += ' g912';
    rules += ' _oa12';
    rules += ' Td12';
    rules += ' Qd12';
    rules += ' Sd12';
    rules += ' Rd12';
    rules += ' p40ub4c12';
    rules += ' -_8sjo0b-t5ZbAob12';
    return rules;
};
const ClearButton = /*#__PURE__*/ (0, _react.forwardRef)(function ClearButton(props, ref) {
    let { size = 'M', isStaticColor = false, ...rest } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...rest,
        ref: domRef,
        style: (0, _pressScale.pressScale)(domRef),
        className: (renderProps)=>visibleClearButton({
                ...renderProps,
                size,
                isStaticColor
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crossDefault.default), {
            size: props.size
        })
    });
});

},{"0":"jHckW","react/jsx-runtime":"2Is6Z","react-aria-components":"9G5XO","../ui-icons/Cross":"5E2vn","react":"a1TxN","./pressScale":"8Ufux","@react-spectrum/utils":"jqfrX","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jHckW":[function() {},{}],"cSREm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.53 17.47-5.083-5.084C14.417 11.186 15 9.66 15 8c0-3.86-3.14-7-7-7S1 4.14 1 8s3.14 7 7 7c1.66 0 3.185-.584 4.386-1.553l5.084 5.083c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M8 13.5c-3.032 0-5.5-2.468-5.5-5.5S4.968 2.5 8 2.5s5.5 2.468 5.5 5.5-2.468 5.5-5.5 5.5"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gLtjx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
"use client";
function Example(props) {
    let [selected, setSelected] = (0, _react.useState)(new Set([
        'rulers'
    ]));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                        children: "View"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
                        ...props,
                        selectedKeys: selected,
                        onSelectionChange: setSelected,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "grid",
                                children: "Pixel grid"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "rulers",
                                children: "Rulers"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "comments",
                                isDisabled: true,
                                children: "Comments"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "layout",
                                children: "Layout guides"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "toolbar",
                                children: "Toolbar"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "Current selection: ",
                    selected === 'all' ? 'all' : [
                        ...selected
                    ].join(', ')
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuTrigger","1F0Yz"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dVWHV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
"use client";
function Example() {
    let [style, setStyle] = (0, _react.useState)(new Set([
        'bold'
    ]));
    let [align, setAlign] = (0, _react.useState)(new Set([
        'left'
    ]));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                children: "Edit"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuSection), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Header), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                                    children: "Clipboard"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                children: "Cut"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                children: "Copy"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                children: "Paste"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuSection), {
                        selectionMode: "multiple",
                        selectedKeys: style,
                        onSelectionChange: setStyle,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Header), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                                    children: "Text style"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "bold",
                                children: "Bold"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "italic",
                                children: "Italic"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "underline",
                                children: "Underline"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuSection), {
                        selectionMode: "single",
                        selectedKeys: align,
                        onSelectionChange: setAlign,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Header), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                                    children: "Text alignment"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "left",
                                children: "Left"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "center",
                                children: "Center"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "right",
                                children: "Right"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Header","10r6w"],["Heading","10r6w"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuSection","1F0Yz"],["MenuTrigger","1F0Yz"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"Zt8nY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
            children: "Copy"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                    children: "Copy as plain text"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                    children: "Copy as rich text"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                    children: "Copy URL"
                })
            ]
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuTrigger","1F0Yz"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kmqkh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M7.75 16.465c-.187 0-.374-.07-.52-.21-.298-.287-.308-.762-.02-1.06l4.999-5.197-4.986-5.184c-.288-.297-.279-.772.02-1.06.296-.286.774-.278 1.06.021L13.79 9.48c.28.29.28.749 0 1.039l-5.5 5.716c-.146.154-.344.23-.54.23"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2370J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13 2.5H7c-.414 0-.75-.336-.75-.75S6.586 1 7 1h6c.414 0 .75.336.75.75s-.336.75-.75.75M16.773 14.48q-.022-.046-.05-.09L12.49 7.78V5.493h.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.25c-.414 0-.75.336-.75.75V8c0 .144.041.284.119.404l1.171 1.83-5.686 1.743 2.279-3.574c.076-.12.117-.26.117-.403V4.743c0-.414-.336-.75-.75-.75H6.99c-.414 0-.75.336-.75.75s.336.75.75.75h.5v2.288l-4.213 6.61q-.028.043-.049.09c-.351.761-.29 1.638.164 2.346C3.86 17.562 4.67 18 5.558 18h8.884c.887 0 1.697-.438 2.167-1.173.453-.708.515-1.585.164-2.347m-1.427 1.539c-.193.301-.531.481-.904.481H5.558c-.373 0-.71-.18-.904-.481-.171-.268-.2-.582-.082-.87l.779-1.222 7.768-2.383 2.31 3.604c.117.29.088.604-.083.87"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bneuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 14H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M3.75 5.5h12.5c.414 0 .75-.336.75-.75S16.664 4 16.25 4H3.75c-.414 0-.75.336-.75.75s.336.75.75.75M16.25 9H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75S16.664 9 16.25 9"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"921LY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.795c-.601 0-1.166-.234-1.591-.66l-6.545-6.544c-.876-.877-.876-2.305 0-3.182l6.545-6.545c.849-.85 2.333-.85 3.182 0l6.545 6.545c.876.877.876 2.305 0 3.182l-6.545 6.545c-.425.425-.99.659-1.591.659m0-16.09c-.2 0-.389.078-.53.22L2.925 9.47c-.292.292-.292.768 0 1.06l6.545 6.545c.283.283.778.283 1.06 0l6.545-6.545c.292-.292.292-.768 0-1.06L10.53 2.925c-.141-.142-.33-.22-.53-.22"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 14.998c-.231.008-.456-.073-.627-.228-.33-.365-.33-.92 0-1.285.17-.158.395-.242.626-.234.237-.01.466.08.633.247.162.168.25.394.242.627.012.235-.07.465-.228.639-.174.164-.408.25-.647.234M10 11.625c-.414 0-.75-.336-.75-.75v-5c0-.414.336-.75.75-.75s.75.336.75.75v5c0 .414-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lHsCS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineAlertContext", ()=>InlineAlertContext);
parcelHelpers.export(exports, "InlineAlert", ()=>InlineAlert);
var _jsxRuntime = require("react/jsx-runtime");
var _s2IconAlertTriangle20NSvg = require("../s2wf-icons/S2_Icon_AlertTriangle_20_N.svg");
var _s2IconAlertTriangle20NSvgDefault = parcelHelpers.interopDefault(_s2IconAlertTriangle20NSvg);
var _s2IconCheckmarkCircle20NSvg = require("../s2wf-icons/S2_Icon_CheckmarkCircle_20_N.svg");
var _s2IconCheckmarkCircle20NSvgDefault = parcelHelpers.interopDefault(_s2IconCheckmarkCircle20NSvg);
var _react = require("react");
var _content = require("./Content");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-aria/utils");
var _icon = require("./Icon");
var _s2IconInfoCircle20NSvg = require("../s2wf-icons/S2_Icon_InfoCircle_20_N.svg");
var _s2IconInfoCircle20NSvgDefault = parcelHelpers.interopDefault(_s2IconInfoCircle20NSvg);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _s2IconAlertDiamond20NSvg = require("../s2wf-icons/S2_Icon_AlertDiamond_20_N.svg");
var _s2IconAlertDiamond20NSvgDefault = parcelHelpers.interopDefault(_s2IconAlertDiamond20NSvg);
var _utils1 = require("@react-spectrum/utils");
var _reactAria = require("react-aria");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const InlineAlertContext = /*#__PURE__*/ (0, _react.createContext)(null);
const inlineAlert = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    rules += ' sg12';
    if (!position) rules += ' _Pc12';
    rules += ' _oa12';
    rules += ' Th12';
    rules += ' Qh12';
    rules += ' Sh12';
    rules += ' Rh12';
    rules += ' oc12';
    rules += ' nc12';
    rules += ' kc12';
    rules += ' jc12';
    rules += ' _jf12';
    rules += ' _kc12';
    rules += ' hc12';
    rules += ' mc12';
    rules += ' lc12';
    if (props.fillStyle === "boldFill") rules += ' iA12';
    else if (props.fillStyle === "subtleFill") rules += ' iA12';
    else if (props.fillStyle === "border") {
        if (props.variant === "neutral") rules += ' iy12';
        else if (props.variant === "negative") rules += ' it12';
        else if (props.variant === "notice") rules += ' is12';
        else if (props.variant === "positive") rules += ' il12';
        else if (props.variant === "informative") rules += ' ix12';
    }
    if (props.variant === "neutral") {
        if (props.fillStyle === "boldFill") rules += ' g612';
        else if (props.fillStyle === "subtleFill") rules += ' gI12';
        else if (props.fillStyle === "border") rules += ' gX12';
    } else if (props.variant === "negative") {
        if (props.fillStyle === "boldFill") rules += ' gB12';
        else if (props.fillStyle === "subtleFill") rules += ' gU12';
        else if (props.fillStyle === "border") rules += ' gX12';
    } else if (props.variant === "notice") {
        if (props.fillStyle === "boldFill") rules += ' gQ12';
        else if (props.fillStyle === "subtleFill") rules += ' gV12';
        else if (props.fillStyle === "border") rules += ' gX12';
    } else if (props.variant === "positive") {
        if (props.fillStyle === "boldFill") rules += ' g112';
        else if (props.fillStyle === "subtleFill") rules += ' gA12';
        else if (props.fillStyle === "border") rules += ' gX12';
    } else if (props.variant === "informative") {
        if (props.fillStyle === "boldFill") rules += ' g212';
        else if (props.fillStyle === "subtleFill") rules += ' gG12';
        else if (props.fillStyle === "border") rules += ' gX12';
    }
    return rules;
};
const icon = function anonymous(props) {
    let rules = " ";
    rules += ' __wa12';
    if (props.fillStyle === "boldFill") {
        if (props.variant === "notice") rules += ' -_8sjo0b-tcwrnr12';
        else rules += ' -_8sjo0b-tw12';
    } else if (props.fillStyle === "subtleFill") {
        if (props.variant === "neutral") rules += ' -_8sjo0b-tf12';
        else if (props.variant === "negative") rules += ' -_8sjo0b-tq12';
        else if (props.variant === "notice") rules += ' -_8sjo0b-tq12';
        else if (props.variant === "positive") rules += ' -_8sjo0b-tt12';
        else if (props.variant === "informative") rules += ' -_8sjo0b-tu12';
    } else if (props.fillStyle === "border") {
        if (props.variant === "neutral") rules += ' -_8sjo0b-tf12';
        else if (props.variant === "negative") rules += ' -_8sjo0b-tq12';
        else if (props.variant === "notice") rules += ' -_8sjo0b-tm12';
        else if (props.variant === "positive") rules += ' -_8sjo0b-tt12';
        else if (props.variant === "informative") rules += ' -_8sjo0b-tu12';
    }
    return rules;
};
let ICONS = {
    informative: (0, _s2IconInfoCircle20NSvgDefault.default),
    positive: (0, _s2IconCheckmarkCircle20NSvgDefault.default),
    notice: (0, _s2IconAlertDiamond20NSvgDefault.default),
    negative: (0, _s2IconAlertTriangle20NSvgDefault.default),
    neutral: undefined
};
const heading = function anonymous(props) {
    let rules = " ";
    rules += ' Jy12';
    rules += ' uk12';
    rules += ' uch12';
    rules += ' udi12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    rules += ' -_6BNtrc-c12';
    rules += ' vx12';
    rules += ' xd12';
    rules += ' _xa12';
    rules += ' xX0cczbc12';
    rules += ' _xX0cczba12';
    rules += ' xfd12';
    rules += ' _xfa12';
    rules += ' xfX0cczbc12';
    rules += ' _xfX0cczba12';
    rules += ' _Fd12';
    rules += ' _FezxGHba12';
    rules += ' _FnuYUweb12';
    if (props.fillStyle === "boldFill") {
        if (props.variant === "notice") rules += ' pg12';
        else rules += ' px12';
    } else rules += ' po12';
    return rules;
};
const content = function anonymous(props) {
    let rules = " ";
    rules += ' uk12';
    rules += ' uch12';
    rules += ' udi12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    rules += ' -_6BNtrc-c12';
    rules += ' vx12';
    rules += ' xb12';
    rules += ' _xa12';
    rules += ' _Fb12';
    rules += ' _FnuYUwec12';
    if (props.fillStyle === "boldFill") {
        if (props.variant === "notice") rules += ' pg12';
        else rules += ' px12';
    } else rules += ' pt12';
    return rules;
};
const InlineAlert = /*#__PURE__*/ (0, _react.forwardRef)(function InlineAlert(props, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, InlineAlertContext);
    let { children, variant = 'neutral', fillStyle = 'border', autoFocus } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let Icon = null;
    let iconAlt = '';
    if (variant in ICONS) {
        Icon = ICONS[variant];
        if (Icon) iconAlt = stringFormatter.format(`inlinealert.${variant}`);
    }
    let { isFocusVisible, focusProps } = (0, _reactAria.useFocusRing)({
        autoFocus: props.autoFocus
    });
    let autoFocusRef = (0, _react.useRef)(props.autoFocus);
    (0, _react.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) domRef.current.focus();
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...(0, _utils.filterDOMProps)(props),
        ...focusProps,
        ref: domRef,
        tabIndex: autoFocus ? -1 : undefined,
        autoFocus: autoFocus,
        role: "alert",
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + inlineAlert({
            variant,
            fillStyle,
            isFocusVisible
        }, props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _content.HeadingContext),
                    {
                        styles: heading({
                            fillStyle
                        })
                    }
                ],
                [
                    (0, _content.ContentContext),
                    {
                        styles: content({
                            fillStyle
                        })
                    }
                ],
                [
                    (0, _icon.IconContext),
                    {
                        styles: icon({
                            variant,
                            fillStyle
                        })
                    }
                ]
            ],
            children: [
                Icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                    "aria-label": iconAlt
                }),
                children
            ]
        })
    });
});

},{"0":"acJkl","1":"fdBhW","2":"knKAC","3":"8iSQ4","react/jsx-runtime":"2Is6Z","../s2wf-icons/S2_Icon_AlertTriangle_20_N.svg":"jyuVv","../s2wf-icons/S2_Icon_CheckmarkCircle_20_N.svg":"6hpGX","react":"a1TxN","./Content":"10r6w","react-aria-components":"bA6Cz","@react-aria/utils":"3upVm","./Icon":"jQAJE","../s2wf-icons/S2_Icon_InfoCircle_20_N.svg":"hByEX","../intl/*.json":"gDH3q","../s2wf-icons/S2_Icon_AlertDiamond_20_N.svg":"921LY","@react-spectrum/utils":"jqfrX","react-aria":"6TXyU","@react-aria/i18n":"7lxyl","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"acJkl":[function() {},{}],"fdBhW":[function() {},{}],"knKAC":[function() {},{}],"8iSQ4":[function() {},{}]},[], null, "parcelRequire7f0c", {}, "./", "https://reactspectrum.blob.core.windows.net/reactspectrum/979ccdf063481013129b0a36c3bdfb0d9e439178/s2-docs/")

//# sourceMappingURL=Menu.414d31d3.js.map
